{
  "app": {
    "title": "Pipeup - the smart CRM"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "loading": "Loading...",
    "cnpjLabel": "KVK",
    "countries": {
      "br": "BR (+55)",
      "nl": "NL (+31)",
      "pt": "PT (+351)",
      "es": "ES (+34)",
      "de": "DE (+49)",
      "fr": "FR (+33)",
      "uk": "UK (+44)",
      "be": "BE (+32)",
      "it": "IT (+39)"
    }
  },
  "auth": {
    "carousel": {
      "logoAlt": "Pipeup Logo",
      "crmLabel": "PIPEUP CRM",
      "slide1Title": "Turn your sales process into predictable results",
      "slide1Subtitle": "Manage pipeline, activities and deals in one place.",
      "slide2Title": "Stop losing opportunities to disorganization",
      "slide2Subtitle": "Centralize leads, contacts and deals in pipeup.",
      "slide3Title": "Full control of your sales pipeline",
      "slide3Subtitle": "See which stage each deal is in — with no effort.",
      "slide4Title": "More focus on the team, less manual work",
      "slide4Subtitle": "Automate tasks and track everything in real time.",
      "slide5Title": "Better decisions",
      "slide5TitleLine2": "with clear data",
      "slide5Subtitle": "Metrics, performance and forecasts always visible.",
      "goToMessage": "Go to message {{n}}",
      "messageN": "Message {{n}}"
    }
  },
  "forgotPassword": {
    "title": "recover access",
    "subtitle": "enter your email to receive a verification code",
    "email": "email",
    "emailPlaceholder": "you@email.com",
    "submit": "send code",
    "submitting": "sending...",
    "backToLogin": "Back to login"
  },
  "signup": {
    "title": "create your account",
    "subtitle": "start your journey with pipeup",
    "companyName": "company name",
    "companyNamePlaceholder": "My Company Inc",
    "cnpj": "CNPJ",
    "cnpjPlaceholder": "00.000.000/0000-00",
    "kvk": "KVK",
    "kvkPlaceholder": "12345678",
    "cnpjRequired": "CNPJ is required",
    "cnpjDigits": "CNPJ must have 14 digits",
    "cnpjInvalid": "Invalid CNPJ",
    "kvkRequired": "KVK is required",
    "kvkDigits": "KVK must have 8 digits",
    "kvkInvalid": "Invalid KVK",
    "phone": "phone / whatsapp",
    "phonePlaceholder": "+31 6 123 45 678",
    "phoneCountry": "Country",
    "phoneRequired": "Phone is required",
    "phoneInvalidLength": "Number must be between {{min}} and {{max}} digits",
    "userName": "your name",
    "userNamePlaceholder": "John Smith",
    "email": "email",
    "emailPlaceholder": "you@email.com",
    "password": "password",
    "passwordPlaceholder": "••••••••",
    "confirmPassword": "confirm password",
    "confirmPasswordPlaceholder": "Repeat your password",
    "submit": "create account",
    "submitting": "creating account...",
    "hasAccount": "Already have an account?",
    "doLogin": "Sign in",
    "footer": "By continuing, you agree to our Terms of Service and Privacy Policy."
  },
  "planSelection": {
    "leftTitle": "Choose the right plan for your team to grow",
    "leftSubtitle": "Try Pipeup for 7 days with full access. The plan only defines how many people use the system.",
    "noCreditCard": "No credit card required",
    "cancelAnytime": "Cancel anytime",
    "title": "Choose your plan",
    "subtitle": "You can change your plan at any time",
    "loadingPlans": "Loading plans...",
    "errorLoad": "Error loading plans. Please refresh the page or contact support.",
    "errorNote": "Note: The /api/plans endpoint must be public (no authentication required).",
    "trialNote": "During the trial, you already use the limits of the chosen plan. We do not ask for a credit card to start.",
    "hasAccount": "Already have an account?",
    "doLogin": "Sign in"
  },
  "login": {
    "welcomeBack": "welcome back",
    "subtitle": "sign in to your pipeup account",
    "email": "email",
    "emailPlaceholder": "you@email.com",
    "password": "password",
    "passwordPlaceholder": "••••••••",
    "rememberMe": "remember me",
    "forgotPassword": "forgot your password?",
    "submit": "sign in",
    "submitting": "signing in...",
    "noAccount": "Don't have an account?",
    "createAccount": "Create my free account",
    "footerPrefix": "By continuing, you agree to our",
    "termsOfService": "Terms of Service",
    "footerAnd": "and",
    "privacyPolicy": "Privacy Policy",
    "footerSuffix": ".",
    "logoAlt": "Pipeup Logo",
    "fillAllFields": "Please fill in all fields.",
    "success": "Login successful!",
    "errorGeneric": "Login failed. Please try again.",
    "errorAuthenticationFailed": "Authentication failed. Please check your email and password and try again.",
    "errorCredentials": "Please check your email and password and try again.",
    "errorServiceUnavailable": "Service is temporarily unavailable. Please try again in a few moments.",
    "errorServer": "Temporary server error. Please try again in a few moments.",
    "subscriptionExpired": "Your subscription has expired. Update your payment to continue using the system.",
    "subscriptionPastDue": "Your subscription has a pending payment. Update your payment to continue using the system.",
    "trialExpired": "Your trial has expired. Choose a plan to continue.",
    "noSubscription": "You do not have an active subscription. Choose a plan to continue."
  },
  "subscriptionGuard": {
    "noSubscription": "You do not have an active subscription. Choose a plan to continue.",
    "subscriptionExpired": "Your subscription has expired. Update your payment to continue using the system.",
    "subscriptionPastDue": "Your subscription has a pending payment. Update your payment to continue using the system.",
    "trialExpired": "Your trial has expired. Choose a plan to continue.",
    "checkError": "Error checking subscription. Please try again."
  },
  "billing": {
    "paywallNeedsAttention": "Your subscription needs attention before you can continue using the system.",
    "previewLoadError": "Could not load the summary. Please try again.",
    "portalOpenError": "Could not open it. Please try again.",
    "subscriptionLoadError": "Error loading the subscription. Please try again.",
    "statusTrial": "TRIAL",
    "statusActive": "ACTIVE",
    "statusPending": "PENDING",
    "statusExpired": "EXPIRED",
    "summaryPlan": "Plan {{planName}}",
    "summaryExtraUsers": "Additional users ({{count}}x)",
    "summarySalesCopilot": "Sales Copilot ({{count}} users)",
    "summaryAmountPerMonth": "{{amount}} / month",
    "summaryTotalMonthly": "Monthly total: {{amount}}",
    "summaryChargedSemiannually": "Billed semiannually: {{amount}}",
    "summaryChargedAnnually": "Billed annually: {{amount}}",
    "cycleMonthly": "Monthly",
    "cycleSemiannual": "Semiannual",
    "cycleAnnual": "Annual"
  },
  "subscriptionCurrent": {
    "cancelSuccess": "Subscription canceled. You will keep access until the end of the current period.",
    "cancelError": "Error canceling subscription. Please try again.",
    "paymentStatusPaid": "Paid",
    "paymentStatusPending": "Pending",
    "paymentStatusCanceled": "Canceled",
    "paymentMethodCreditCard": "Card",
    "paymentMethodBankSlip": "Bank slip",
    "receiptUnavailable": "Receipt unavailable."
  },
  "subscriptionCurrentTemplate": {
    "title": "Subscription",
    "subtitle": "Manage your plan",
    "changePlan": "Change plan",
    "cancelSubscription": "Cancel subscription",
    "loadingSubscription": "Loading subscription...",
    "planTitle": "Plan {{planCode}}",
    "activeBadge": "ACTIVE",
    "value": "Value",
    "cycle": "Cycle",
    "nextBilling": "Next billing",
    "seats": "Seats",
    "manageSeatsAndAddOns": "Manage seats and add-ons",
    "used": "Used:",
    "usedSeatsValue": "{{used}} of {{total}} seats",
    "includedInPlan": "Included in the plan:",
    "extraSeats": "+ {{count}} extras",
    "addOns": "Add-ons",
    "manageUsers": "Manage users",
    "enabledUsers": "{{count}} enabled user(s)",
    "perSubscription": "Per subscription",
    "perUserSuffix": " / user",
    "loadingHistory": "Loading history...",
    "noPaymentsFound": "No payments found",
    "historyWillAppear": "The history will appear here after charges.",
    "date": "Date",
    "description": "Description",
    "status": "Status",
    "currentPageReport": "Showing {first} to {last} of {totalRecords} payments",
    "changePlanSoon": "Soon you will be able to change your plan here. For now, contact support.",
    "close": "Close",
    "cancelConfirm": "Are you sure you want to cancel the subscription? You will keep access until {{date}}.",
    "cannotBeUndone": "This action cannot be undone.",
    "cancel": "Cancel",
    "canceling": "Canceling..."
  },
  "subscriptionPayment": {
    "template": {
      "heroTitle": "Keep full access",
      "heroSubtitle": "Activate your subscription and keep your team working without interruptions.",
      "heroBulletSecure": "• Secure payment",
      "heroBulletChangePlan": "• You can change plans whenever you want",
      "logoAlt": "Pipeup logo",
      "selectedPlanLabel": "Selected plan",
      "perMonth": "/month",
      "planDescriptions": {
        "pro": "Everything you need to run sales efficiently",
        "scale": "For management, scale, and strategic decisions"
      },
      "changePlanAction": "change plan",
      "activateTitle": "Activate your subscription",
      "activateSubtitle": "Choose a payment method to complete it.",
      "loading": "Loading information...",
      "changeSummaryTitle": "Change summary",
      "whatChangesNow": "What changes now:",
      "whatChangesNextCycle": "What changes next cycle:",
      "chargeNow": "Amount to be charged now:",
      "nextInvoiceEstimate": "Estimated next invoice amount:",
      "selectPaymentAndConfirm": "Select a payment method below and confirm.",
      "confirmAndPay": "Confirm and pay",
      "processing": "Processing...",
      "confirmChange": "Confirm change",
      "scheduling": "Scheduling...",
      "back": "Back",
      "choosePaymentMethod": "Choose a payment method",
      "activateSubscription": "Activate subscription",
      "calculating": "Calculating...",
      "keepSelectedPlan": "You will remain on the selected plan.",
      "paymentViaPix": "Payment via PIX",
      "paymentViaCard": "Payment via card",
      "paymentViaBankSlip": "Payment via bank slip",
      "amountToPay": "Amount to pay:",
      "semiannualSuffix": "(semiannual)",
      "annualSuffix": "(annual)",
      "expiresIn": "Expires in:",
      "paymentExpiredCreateNew": "Payment expired. Create a new checkout.",
      "qrCodeMissing": "Error: QR code was not returned. Check the console for more details.",
      "paymentUrlMissingDetails": "Error: Payment URL was not returned. Check the console for more details.",
      "qrCodeAlt": "PIX QR code",
      "pixCodeLabel": "PIX code (Copy and Paste):",
      "pixCodeShort": "PIX code",
      "copy": "Copy",
      "pixInstructionsLine1": "Scan the QR code with your bank app",
      "pixInstructionsLine2": "or copy the PIX code.",
      "awaitingPaymentConfirmation": "Waiting for payment confirmation...",
      "paymentConfirmedRedirecting": "Payment confirmed! Redirecting...",
      "secureCheckoutRedirect": "You will be redirected to the secure checkout.",
      "goToCheckout": "Go to checkout",
      "downloadBankSlipPrompt": "Click the button below to download the bank slip",
      "downloadBankSlip": "Download bank slip",
      "bankSlipInstructions": "The bank slip is due within up to 3 business days. After payment, your subscription will be activated automatically.",
      "chooseAnotherPaymentMethod": "Choose another payment method",
      "cancelAndGoBack": "Cancel and go back",
      "changePlanModalTitle": "Change plan",
      "planOptionDescriptions": {
        "pro": "For small and medium-sized teams that want to run sales efficiently",
        "scale": "For management, scale, and strategic decisions"
      },
      "upToIncludedUsers": "Up to {{count}} included users",
      "currentPlan": "Current Plan",
      "select": "Select",
      "changing": "Changing..."
    },
    "paymentMethods": {
      "pix": {
        "label": "PIX",
        "description": "Instant payment"
      },
      "creditCard": {
        "label": "Credit Card",
        "description": "Monthly recurring"
      },
      "bankSlip": {
        "label": "Bank Slip",
        "description": "Clears within up to 3 days"
      }
    },
    "statusMessage": {
      "default": "Your subscription has expired or has a pending issue. Complete payment to keep using the system."
    },
    "toasts": {
      "selectPaymentMethod": "Please select a payment method",
      "selectBillingCycle": "Please select a billing cycle",
      "selectPaymentMethodFirst": "Select a payment method first.",
      "selectPaymentMethodForConfirmation": "Select a payment method."
    },
    "warnings": {
      "mockQrCode": "⚠️ Using a mock QR code (backend did not return data)"
    },
    "errors": {
      "backendMethodMismatch": "Error: Backend returned method \"{{backendMethod}}\" but you selected \"{{selectedMethod}}\"",
      "paymentUrlMissing": "Error: Payment URL was not returned by the server for {{paymentMethod}}",
      "unknownPaymentMethod": "Error: Unknown payment method: {{paymentMethod}}",
      "createCheckout": "Error creating checkout. Please try again.",
      "checkoutEndpointNotFound": "Checkout endpoint not found. Verify the backend is configured correctly.",
      "invalidData": "Invalid data. Check the information and try again.",
      "sessionExpired": "Session expired. Please log in again.",
      "server": "Server error. Please try again in a few moments.",
      "generateQrCode": "Error generating QR code",
      "copyToClipboard": "Error copying to clipboard",
      "changePlan": "Error changing plan. Please try again.",
      "scheduleChange": "Error scheduling change. Please try again."
    },
    "success": {
      "copiedToClipboard": "{{label}} copied to clipboard!",
      "changeScheduled": "Change scheduled for the next cycle.",
      "paymentConfirmedRedirecting": "Payment confirmed! Redirecting..."
    },
    "changeSummary": {
      "planChanged": "Plan changed to {{planName}} ({{cycleName}}).",
      "immediateProrated": "The change will be applied immediately and the prorated amount will be charged now.",
      "nextCycle": "The change will be applied in the next billing cycle.",
      "cycleChanged": "Cycle changed to {{cycleName}}.",
      "immediateCharge": "The change will be applied immediately and the amount will be charged now.",
      "monthlyNextCycle": "Monthly billing starting next cycle.",
      "monthlyAtPeriodEnd": "The switch to monthly billing will be applied at the end of the current contracted period."
    },
    "expiration": {
      "expired": "Expired"
    }
  },
  "companyPreferences": {
    "title": "Preferences",
    "language": {
      "label": "Platform language",
      "helper": "Controls the system language. You can change it anytime."
    },
    "accentColor": {
      "title": "Accent color",
      "description": "Customize buttons and highlights on proposals and PDFs (limited scope).",
      "label": "Accent color",
      "contrastHint": "Text color is automatically adjusted for best contrast."
    }
  },
  "sidebar": {
    "sectionGeneral": "general",
    "sectionTools": "tools",
    "sectionAdmin": "administration",
    "dashboard": "dashboard",
    "inbox": "inbox",
    "agenda": "calendar",
    "leads": "leads",
    "pipeline": "pipeline",
    "registrations": "records",
    "contacts": "contacts",
    "companies": "companies",
    "automations": "automations",
    "integrations": "integrations",
    "reports": "reports",
    "commercial": "commercial",
    "pipelines": "pipelines",
    "lostReasons": "lost reasons",
    "customFields": "custom fields",
    "brands": "brands",
    "products": "products",
    "proposalTemplates": "proposals",
    "channels": "channels",
    "channelsConfig": "settings",
    "marketing": "marketing",
    "marketingTags": "tags",
    "marketingSegments": "segments",
    "marketingTemplates": "templates",
    "marketingCampaigns": "campaigns",
    "account": "account",
    "company": "company",
    "users": "users",
    "profiles": "profiles",
    "subscription": "subscription"
  },
  "header": {
    "create": "Create",
    "newLead": "New lead",
    "newDeal": "New deal",
    "newActivity": "New activity",
    "newProposal": "New proposal",
    "notifications": "Notifications",
    "notificationsCount": "{{count}} notifications",
    "markAllAsRead": "Mark all as read",
    "noNotifications": "No notifications",
    "user": "User",
    "company": "Company",
    "profile": "Profile",
    "logout": "Log out",
    "avatar": "Avatar",
    "trialExpired": "Trial ended",
    "trialDaysOne": "Trial • 1 day",
    "trialDays": "Trial • {{days}} days",
    "trialTooltipWarning": "Your trial period is coming to an end.",
    "trialTooltipDanger": "Your trial is almost over. Upgrade to keep using the system.",
    "roleMember": "Member",
    "relativeNow": "now",
    "relativeMin": "{{count}} min ago",
    "relativeHour": "{{count}}h ago",
    "relativeDay": "{{count}}d ago"
  },
  "account": {
    "title": "My Data",
    "subtitle": "Manage your personal information",
    "loading": "Loading your data...",
    "identificationTitle": "Identification Information",
    "profilePhoto": "Profile Photo",
    "avatarPlaceholder": "https://example.com/avatar.jpg",
    "changePhoto": "Change Photo",
    "selectPhoto": "Select",
    "avatarHintNoPhoto": "Paste your profile photo URL or select an image",
    "avatarHintWithPhoto": "Click \"Change Photo\" to update your profile picture",
    "email": "Email",
    "company": "Company",
    "profile": "Profile",
    "noValue": "—",
    "personalInfoTitle": "Personal Information",
    "name": "Name",
    "namePlaceholder": "e.g. John Smith",
    "phone": "Phone",
    "phonePlaceholder": "(11) 99999-9999",
    "sameNumberWhatsApp": "Same number used for WhatsApp",
    "whatsappNumber": "WhatsApp Number",
    "timezone": "Time Zone",
    "timezonePlaceholder": "Select a time zone",
    "saving": "Saving...",
    "saveChanges": "Save Changes",
    "errors": {
      "load": "Error loading your data. Please try again.",
      "update": "Error updating your data. Please try again.",
      "nameRequired": "Name is required",
      "phoneRequired": "Phone is required",
      "invalidFormat": "Invalid format. Use: +5511999999999",
      "timezoneRequired": "Time zone is required",
      "timezoneInvalid": "Invalid timezone format. Use IANA format (e.g. America/Sao_Paulo)",
      "imageOnly": "Only image files are allowed (JPG, PNG, GIF, WEBP).",
      "fileSize": "File must be at most 2.5MB.",
      "imageDimensions": "Image must be at most 198x198 pixels.",
      "imageLoad": "Error loading image.",
      "fileRead": "Error reading file.",
      "avatarUpload": "Error uploading avatar."
    },
    "success": {
      "updated": "Data updated successfully!",
      "avatarUpdated": "Avatar updated successfully!"
    }
  },
  "subscription": {
    "title": "Subscription",
    "subtitle": "Manage plan, seats, add-ons and payments for your account.",
    "tabPrincipal": "Main",
    "tabHistorico": "History",
    "loading": "Loading subscription...",
    "errorLoadTitle": "Error loading subscription",
    "errorLoadMessage": "Could not load subscription information.",
    "tryAgain": "Try again",
    "noSubscriptionTitle": "No active subscription",
    "noSubscriptionChoose": "Choose a plan to get started:",
    "upToUsers": "Up to {{count}} users included",
    "startTrial": "Start trial",
    "perMonth": "/month",
    "alertPastDueTitle": "Subscription with pending payment",
    "alertPastDueMessage": "Your payment is overdue. Update it to keep using the system.",
    "alertExpiredMessage": "Your subscription has expired. Renew to keep using the system.",
    "regularize": "Update payment",
    "billingCycle": "Billing cycle:",
    "nextBilling": "Next billing:",
    "trialEndsOn": "Your trial ends on {{date}}",
    "accountUpToDate": "Account up to date",
    "attentionRegularize": "Attention: update payment to maintain full access",
    "whatYouHaveContracted": "What you have contracted",
    "plan": "Plan",
    "extraSeats": "Additional seats ({{count}})",
    "totalEstimated": "Total estimated",
    "doUpgrade": "Upgrade",
    "changePlan": "Change plan",
    "cancelSubscription": "Cancel subscription",
    "scheduledChangeTitle": "Change scheduled for next cycle",
    "cancelScheduledTitle": "Cancellation scheduled",
    "cancelScheduledMessage": "Your subscription will be canceled at the end of the current period. You keep access until then.",
    "changePlanModalTitle": "Change plan",
    "currentPlan": "Current plan:",
    "loadingPlans": "Loading plans...",
    "whatChangesNow": "What changes now:",
    "whatChangesNextCycle": "What changes next cycle:",
    "chargeNow": "Amount to be charged now:",
    "nextInvoiceEstimate": "Estimated next invoice amount:",
    "paymentMethod": "Payment method",
    "confirmAndPay": "Confirm and pay",
    "processing": "Processing...",
    "confirmChange": "Confirm change",
    "scheduling": "Scheduling...",
    "back": "Back",
    "seatsTitle": "Seats",
    "seatsSubtitle": "Manage who uses seats and overage costs.",
    "additionPerSeat": "Addition: {{price}} / seat",
    "manageSeats": "Manage seats",
    "used": "Used:",
    "ofSeats": "{{used}} of {{total}} seats",
    "includedInPlan": "Included in plan:",
    "extraSeatsBadge": "Extra seats: {{count}}",
    "addonsTitle": "Add-ons",
    "addonsSubtitle": "Enable additional features as needed. Add-ons and extra seats are charged on the spot.",
    "available": "Available",
    "perUser": "Per user",
    "perUserShort": "user",
    "perSubscription": "Per subscription",
    "contract": "Subscribe",
    "contracted": "Subscribed",
    "addition": "Addition",
    "additionPerUser": "Addition: {{price}} / user",
    "manageUsers": "Manage users",
    "historyTitle": "Payment history",
    "historySubtitle": "View invoices, status and receipts.",
    "loadingHistory": "Loading history...",
    "noPayments": "No payments found yet.",
    "period": "Period",
    "planCol": "Plan",
    "value": "Amount",
    "status": "Status",
    "method": "Method",
    "dueDate": "Due date",
    "paidOn": "Paid on",
    "actions": "Actions",
    "downloadPdf": "Download PDF",
    "statusPaid": "Paid",
    "statusPending": "Pending",
    "statusFailed": "Failed",
    "statusRefunded": "Refunded",
    "modalSeatsTitle": "Plan seats",
    "modalSeatsSubtitle": "Manage users and add new seats",
    "addNewSeat": "Add new seat",
    "addSeatHint": "Billing is immediate and prorated for the current period. You can then assign who will use the seat.",
    "addSeatHint2": "No additional recurring charge is created without your confirmation.",
    "quantityNewSeats": "Number of new seats",
    "addSeatAndPay": "Add seat and pay now",
    "trialNoExtraSeats": "During trial you cannot add extra seats. After the first charge, you can add and pay on the spot.",
    "cancelModalTitle": "Cancel subscription",
    "cancelModalRegistered": "Cancellation registered",
    "cancelModalConfirmText": "By confirming, your subscription will be canceled at the end of the current period.",
    "cancelModalAccessUntil": "You keep access until then.",
    "cancelModalTypeCompany": "To confirm, type the company name",
    "noKeepSubscription": "No, keep subscription",
    "confirmCancellation": "Confirm cancellation",
    "registeringCancellation": "Registering cancellation...",
    "refundEligible": "You are eligible for a refund. Deadline: {{date}}.",
    "effectiveCancellationOn": "Effective cancellation on:",
    "close": "Close",
    "removeAccessTitle": "Remove access?",
    "removeAccessUserLoses": "This user will lose access to the workspace.",
    "removeAccessSeatFreed": "The seat will be freed immediately.",
    "removeAccessDataPreserved": "Data and history will remain preserved.",
    "removeAccess": "Remove access",
    "removing": "Removing…",
    "contractAddon": "Subscribe:",
    "manageAddonUsers": "Manage which users have access to this add-on",
    "willBeEnabled": "Will be enabled",
    "enable": "Enable",
    "unmark": "Unmark",
    "disabled": "Disable",
    "enabled": "Enabled",
    "usersWithAddon": "{{count}} user(s) with {{name}} active",
    "selectUsersToEnable": "Select users above to enable {{name}}. Billing is immediate and prorated for the current period.",
    "contractAndPay": "Subscribe and pay",
    "enableAddonAndPay": "Enable {{name}} and pay now",
    "chargeImmediateHint": "Billing is immediate and prorated. You can later enable for more users in Manage users.",
    "statusTrial": "Trial",
    "statusActive": "Active",
    "statusPastDue": "Payment pending",
    "statusCanceled": "Canceled",
    "statusExpired": "Expired",
    "daysRemaining": "{{count}} days remaining"
  },
  "dashboard": {
    "title": "Dashboard",
    "attention": {
      "title": "Immediate attention",
      "dealsCount": "{{count}} deals",
      "daysNoAction": "{{days}} days with no action",
      "viewDeals": "View deals",
      "empty": "No deals need attention at the moment."
    },
    "myActivities": {
      "title": "My activities",
      "overdue": "OVERDUE",
      "empty": "No activities for today"
    },
    "hotDeals": {
      "title": "Deals closest to closing",
      "empty": "No deals close to closing at the moment."
    },
    "pipelineSummary": {
      "title": "Pipeline summary",
      "lastDays": "Last {{days}} days",
      "createDeal": "Create deal",
      "selectPipeline": "Select a pipeline",
      "viewFullPipeline": "View full pipeline",
      "retry": "Try again",
      "noPipelines": "You don't have any pipelines yet.",
      "createPipeline": "Create pipeline",
      "topFunnel": "Top of funnel",
      "middleFunnel": "Middle of funnel",
      "bottomFunnel": "Bottom of funnel"
    },
    "summaryBox": {
      "deals": "deals",
      "dealsWithCount": "{{count}} deals",
      "stages": "stages",
      "oneStage": "1 stage",
    "stageCount": "{{count}} stages",
      "totalInPeriod": "Total in selected period",
      "noDealsInPeriod": "No deals in this period",
      "viewDeals": "View deals",
      "addDeal": "Add deal"
    },
    "conversion": {
      "label": "Conversion rate",
      "noData": "No data",
      "lastDays": "Last {{days}} days",
      "noDataInPeriod": "No data in period",
      "viewWon": "View won in period",
      "viewCreated": "View created in period",
      "wonOfCreated": "{{won}} won of {{created}} created",
      "vsPrevious": "vs previous period"
    },
    "performance": {
      "title": "Performance",
      "last30Days": "Last 30 days",
      "noDataInPeriod": "No data in period",
      "loading": "Loading…",
      "loadError": "Could not load data.",
      "noDataSelected": "No data in selected period.",
      "chartLeadsCreated": "Leads created",
      "chartDealsCreated": "Deals created",
      "chartDealsWon": "Deals won",
      "chartDealsLost": "Deals lost"
    },
    "errors": {
      "sessionExpired": "Session expired",
      "notFound": "Resource not found",
      "tooManyRequests": "Too many requests. Please wait and try again.",
      "serverError": "Server error. Please try again.",
      "noConnection": "No connection to server",
      "loadError": "Error loading data"
    },
    "attentionTitles": {
      "dealsNoActivity3": "Deals with no activity for 3 days",
      "proposals48h": "Proposals sent over 48h ago with no response",
      "dealsStuck7": "Deals stuck in same stage for 7 days"
    },
    "noValue": "No value",
    "na": "N/A"
  },
  "automations": {
    "title": "Automations",
    "subtitle": "Create simple rules: When something happens → Do an action.",
    "newAutomation": "New Automation",
    "searchPlaceholder": "Search automation…",
    "filterStatusAll": "All",
    "filterStatusActive": "Active",
    "filterStatusInactive": "Inactive",
    "filterEventAll": "All types",
    "sortRecent": "Most recent",
    "sortName": "Name A–Z",
    "sortStatus": "Status (active first)",
    "search": "Search",
    "loading": "Loading automations...",
    "emptyTitle": "You don't have any automations yet.",
    "emptySubtitle": "Create your first automation to automate repetitive tasks.",
    "createFirst": "Create first automation",
    "emptyFiltered": "No automations found for the selected filters.",
    "clearFilters": "Clear filters",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "createdAt": "Created on",
    "updatedAt": "Updated on",
    "editTitle": "Edit automation",
    "deleteTitle": "Delete automation",
    "paginatorTemplate": "Showing {first} to {last} of {totalRecords} automations",
    "deleteModal": {
      "title": "Delete Automation",
      "message": "Are you sure you want to delete the automation \"{{name}}\"?",
      "warning": "This action cannot be undone.",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "modal": {
      "titleNew": "New Automation",
      "titleEdit": "Edit Automation",
      "loadingDetails": "Loading automation details...",
      "nameLabel": "Automation Name",
      "namePlaceholder": "E.g.: Create activity after proposal sent",
      "nameChars": "{{count}}/80 characters",
      "applyInLabel": "Apply to",
      "applyInHelper": "Defines where the automation will be applied",
      "selectScope": "Select...",
      "whenLabel": "When",
      "selectEvent": "Select an event",
      "pipelineOptional": "Pipeline (optional)",
      "allPipelines": "All pipelines",
      "pipelineHelper": "If not selected, applies to any pipeline",
      "forStageOptional": "To stage (optional)",
      "selectStage": "Select a stage",
      "selectStageFirst": "Select pipeline first to enable",
      "templateOptional": "Proposal template (optional)",
      "allTemplates": "All templates",
      "useCondition": "Use condition",
      "fieldLabel": "Field",
      "selectField": "Select a field",
      "operatorLabel": "Operator",
      "selectOperator": "Select",
      "valueLabel": "Value",
      "operatorEquals": "is",
      "operatorContains": "contains",
      "operatorNotContains": "does not contain",
      "operatorIsEmpty": "is empty",
      "operatorIsNotEmpty": "is not empty",
      "doLabel": "Do",
      "selectAction": "Select an action",
      "activityTypeLabel": "Activity type",
      "activityTypeSelect": "Select",
      "activityTypeCall": "Call",
      "activityTypeMeeting": "Meeting",
      "activityTypeTask": "Task",
      "activityTypeFollowUp": "Follow-up",
      "titleSubjectLabel": "Title/Subject",
      "titlePlaceholder": "E.g.: Call in 1 day",
      "descriptionOptional": "Description (optional)",
      "dueLabel": "Due",
      "dueImmediate": "Immediate",
      "dueDays": "In X days",
      "daysLabel": "Days",
      "responsibleLabel": "Responsible",
      "keepOwner": "Keep current responsible",
      "assignOwnerOption": "Set responsible",
      "selectResponsible": "Select a responsible",
      "stageDestLabel": "Destination stage",
      "changeStageHelper": "Changes the stage within the same pipeline",
      "pipelineDestLabel": "Destination pipeline",
      "selectPipeline": "Select a pipeline",
      "moveStageHelper": "Moves the item to another pipeline and sets the new stage",
      "optionLabel": "Option",
      "overwriteOwner": "Overwrite current responsible",
      "assignOnlyIfEmpty": "Assign only if empty",
      "summaryTitle": "Summary",
      "summaryPlaceholder": "Fill scope, event and action to see the summary",
      "fixErrors": "Fix the following errors:",
      "saving": "Saving..."
    },
    "summary": {
      "scopeIn": "In {{scope}}: ",
      "when": "When {{event}}",
      "toStage": " to {{stage}}",
      "condition": ", if {{field}} {{operator}} {{value}}",
      "action": " → {{action}}",
      "moveTo": " to {{pipeline}}",
      "moveStage": " / {{stage}}"
    },
    "operators": {
      "equals": "is",
      "contains": "contains",
      "notContains": "does not contain",
      "isEmpty": "is empty",
      "isNotEmpty": "is not empty",
      "greaterThan": "greater than",
      "lessThan": "less than",
      "isTrue": "is true",
      "isFalse": "is false",
      "notEquals": "is not",
      "before": "before",
      "after": "after"
    },
    "scopes": {
      "deal": "Deals",
      "lead": "Leads",
      "proposal": "Proposals"
    }
  },
  "agenda": {
    "title": "Calendar",
    "subtitle": "Manage your scheduled activities",
    "searchPlaceholder": "Search by deal, contact or company…",
    "filterFollowUp": "Follow-up",
    "filterTask": "Task",
    "filterMeeting": "Meeting",
    "summaryTitle": "Day summary",
    "summaryFollowUps": "Follow-ups:",
    "summaryTasks": "Tasks:",
    "summaryMeetings": "Meetings:",
    "summaryOverdue": "Overdue:",
    "noActivitiesDay": "No activities for this day.",
    "overdueTitle": "Overdue",
    "overdueCountOne": "overdue",
    "overdueCountMany": "overdue",
    "viewAll": "View all",
    "noOverdue": "No overdue activities.",
    "activitiesTitle": "Activities",
    "tabToday": "Today",
    "tabNext7": "Next 7 days",
    "tabNext30": "Next 30 days",
    "tabOverdue": "Overdue",
    "tabHint": "Click a day on the calendar to clear selection",
    "loading": "Loading activities...",
    "emptyTitle": "No activities for this day.",
    "emptyAdjustFilters": "Try adjusting your search filters",
    "emptyHint": "Your scheduled activities will appear here",
    "noContact": "No contact",
    "noCompany": "No company",
    "overdueDays": "Overdue by {{days}} {{daysLabel}}",
    "overdueDaysOne": "day",
    "overdueDaysMany": "days",
    "openDeal": "Open deal",
    "noDealLinked": "This activity is not linked to a deal",
    "complete": "Complete",
    "reschedule": "Reschedule",
    "modalCompleteTitle": "Complete Activity",
    "modalCompleteQuestion": "Would you like to add a note about the outcome of this activity?",
    "modalCompleteLabel": "Reason/Result (optional)",
    "modalCompletePlaceholder": "Describe the result or reason for completion...",
    "completing": "Completing...",
    "modalRescheduleTitle": "Reschedule Activity",
    "modalRescheduleLabel": "New Date and Time",
    "confirm": "Confirm",
    "todayAt": "Today {{time}}",
    "weekdayDom": "Sun",
    "weekdayMon": "Mon",
    "weekdayTue": "Tue",
    "weekdayWed": "Wed",
    "weekdayThu": "Thu",
    "weekdayFri": "Fri",
    "weekdaySat": "Sat",
    "monthJan": "Jan",
    "monthFeb": "Feb",
    "monthMar": "Mar",
    "monthApr": "Apr",
    "monthMay": "May",
    "monthJun": "Jun",
    "monthJul": "Jul",
    "monthAug": "Aug",
    "monthSep": "Sep",
    "monthOct": "Oct",
    "monthNov": "Nov",
    "monthDec": "Dec",
    "channelCall": "Call",
    "channelEmail": "Email",
    "channelWhatsApp": "WhatsApp",
    "noteCompletionSubject": "Completion: {{subject}}",
    "errors": {
      "load": "Error loading calendar. Please try again.",
      "noDeal": "This activity is not linked to a deal.",
      "loadDeal": "Error loading deal. Please try again.",
      "complete": "Error completing activity. Please try again.",
      "reschedule": "Error rescheduling activity. Please try again."
    },
    "toast": {
      "completeWithNote": "Activity completed and note recorded successfully!",
      "complete": "Activity completed successfully!",
      "reschedule": "Activity rescheduled successfully!"
    }
  },
  "crmTags": {
    "label": "Tags",
    "addTagPlaceholder": "Add tag…",
    "searchPlaceholder": "Search tag…",
    "helperText": "Use tags to segment campaigns and automations.",
    "removeTag": "Remove tag",
    "noTagsFound": "No tags found.",
    "loading": "Loading tags…",
    "toastAdded": "Tag added",
    "toastRemoved": "Tag removed",
    "toastError": "Could not update tags. Please try again.",
    "tagsColumn": "Tags",
    "tagsQuickAction": "Tags",
    "manageTags": "Manage tags",
    "tagsCountTooltip": "{{count}} tags — click to manage",
    "noTags": "—",
    "noTagsAttributed": "No tags assigned"
  },
  "leads": {
    "title": "Leads",
    "subtitle": "Manage your leads (People and Organizations)",
    "import": "Import",
    "importFile": "Import file (.xlsx)",
    "downloadTemplate": "Download template (.xlsx)",
    "newLead": "New Lead",
    "searchPlaceholder": "Search leads...",
    "filterAllTypes": "All types",
    "typePerson": "Person",
    "typeOrganization": "Company",
    "search": "Search",
    "loading": "Loading leads...",
    "emptyTitle": "No leads found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first lead",
    "tableLead": "Lead",
    "tableType": "Type",
    "tableStatus": "Status",
    "tableContact": "Contact",
    "tableOwner": "Owner",
    "tableCreatedAt": "Created at",
    "tableActions": "Actions",
    "whatsappAvailable": "WhatsApp available",
    "viewActivities": "View activities",
    "editLead": "Edit lead",
    "convertToDeal": "Convert to opportunity",
    "deleteLead": "Delete lead",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} leads",
    "deleteModal": {
      "title": "Delete Lead",
      "message": "Are you sure you want to delete the lead",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "detail": {
      "breadcrumbLeads": "Leads",
      "loading": "Loading...",
      "loadingLead": "Loading lead...",
      "edit": "Edit",
      "activities": "Activities",
      "newActivity": "New activity",
      "filterAll": "All",
      "loadingActivities": "Loading activities...",
      "noActivities": "No activities recorded",
      "noActivitiesHint": "Record the first activity to get started",
      "newActivityTitle": "New Activity",
      "type": "Type",
      "dateTime": "Date/Time",
      "subject": "Subject",
      "subjectPlaceholder": "E.g. Follow-up call",
      "description": "Description",
      "descriptionPlaceholder": "Activity details...",
      "cancel": "Cancel",
      "save": "Save",
      "result": "Result",
      "showMore": "Show more",
      "showLess": "Show less",
      "completed": "Completed",
      "reopen": "Reopen",
      "delete": "Delete",
      "identification": "Identification",
      "responsible": "Owner",
      "active": "Active",
      "inactive": "Inactive",
      "contacts": "Contacts",
      "contact": "Contact",
      "tradeName": "Trade name",
      "cnpj": "KVK",
      "noContact": "No contact registered",
      "actions": "Actions",
      "convertToDeal": "Convert to Deal",
      "archiveLead": "Archive Lead",
      "phoneVerified": "Phone verified",
      "whatsappVerified": "WhatsApp verified",
      "whatsappAvailable": "WhatsApp Available"
    },
    "drawer": {
      "editLead": "Edit Lead",
      "newLead": "New Lead",
      "configureLeadData": "Configure lead data",
      "type": "Type",
      "person": "Person",
      "organization": "Company",
      "name": "Name",
      "contactName": "Contact name",
      "contactNameHintPerson": "Usually same as name",
      "contactNameHintOrg": "Name of the person who represents the company",
      "email": "Email",
      "phone": "Phone",
      "phoneRequired": "Phone is required.",
      "phoneE164": "Phone must be in E.164 format (e.g. +5511987654321 or +31612345678).",
      "phoneFormatHint": "Select country and enter number (will be converted to E.164).",
      "whatsappOptIn": "Allow sending messages via WhatsApp",
      "position": "Position",
      "positionPlaceholder": "E.g. IT Manager",
      "company": "Company",
      "companyPlaceholder": "E.g. TechPro Services",
      "tradeName": "Trade name",
      "tradeNamePlaceholder": "E.g. TechPro",
      "cnpj": "KVK",
      "cnpjPlaceholder": "12345678",
      "cnpjDigitsError": "KVK must have 8 digits.",
      "website": "Website",
      "websitePlaceholder": "https://example.com",
      "industry": "Industry",
      "industryPlaceholder": "E.g. Technology",
      "size": "Size",
      "select": "Select",
      "sizeSmall": "Small",
      "sizeMedium": "Medium",
      "sizeLarge": "Large",
      "sizeEnterprise": "Enterprise",
      "address": "Address",
      "country": "Country",
      "countryPlaceholder": "E.g. Brazil",
      "state": "State",
      "statePlaceholder": "E.g. SP",
      "city": "City",
      "cityPlaceholder": "E.g. São Paulo",
      "addressLine1": "Address",
      "addressLine1Placeholder": "E.g. Av. Paulista, 1000",
      "complement": "Complement",
      "complementPlaceholder": "E.g. Room 101",
      "zipCode": "ZIP Code",
      "zipCodePlaceholder": "01310-100",
      "source": "Source",
      "status": "Status",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "statusNew": "New",
      "statusInContact": "In Contact",
      "statusQualified": "Qualified",
      "description": "Description",
      "descriptionPlaceholder": "Notes about the lead...",
      "responsible": "Owner",
      "selectResponsible": "Select a responsible",
      "customFields": "Custom fields",
      "createDealAfterSave": "Create opportunity after saving",
      "pipeline": "Pipeline",
      "selectPipeline": "Select a pipeline",
      "initialStage": "Initial stage",
      "selectStage": "Select a stage",
      "selectPipelineFirst": "Select a pipeline first",
      "cancel": "Cancel",
      "saveChanges": "Save changes",
      "saveLead": "Save Lead",
      "saving": "Saving...",
      "namePlaceholderPerson": "E.g. João Silva",
      "namePlaceholderOrg": "E.g. TechPro Services Ltd",
      "contactPlaceholderPerson": "E.g. João Silva",
      "contactPlaceholderOrg": "E.g. Maria Santos (person representing the company)",
      "emailPlaceholder": "example@email.com",
      "emailPlaceholderOrg": "contact@company.com.br"
    },
    "convertModal": {
      "title": "Convert to Deal",
      "subtitle": "Create an opportunity from this lead",
      "pipeline": "Pipeline",
      "stage": "Stage",
      "selectPipeline": "Select a pipeline",
      "selectStage": "Select a stage",
      "selectPipelineFirst": "Select a pipeline first",
      "responsible": "Owner",
      "notAssigned": "Not assigned",
      "dealName": "Deal name",
      "dealNamePlaceholder": "E.g. Deal with João Silva",
      "estimatedValue": "Estimated value",
      "expectedDate": "Expected date",
      "cancel": "Cancel",
      "convert": "Convert to Deal",
      "converting": "Converting..."
    },
    "activitiesModal": {
      "title": "Activities",
      "noActivities": "No activities recorded",
      "noActivitiesHint": "Record calls, messages, notes and next steps for this lead.",
      "createFirst": "Create first activity",
      "newBtn": "New",
      "newActivity": "New Activity",
      "type": "Type",
      "subject": "Subject",
      "subjectPlaceholder": "E.g. Follow-up call",
      "description": "Description",
      "descriptionPlaceholder": "Activity details...",
      "dateTime": "Date/Time",
      "direction": "Direction",
      "directionOutbound": "Outbound (you called/sent)",
      "directionInbound": "Inbound (client called/sent)",
      "cancel": "Cancel",
      "create": "Create",
      "result": "Result",
      "completedAt": "Completed at",
      "reopen": "Reopen",
      "complete": "Complete",
      "delete": "Delete"
    },
    "activityTypes": {
      "Call": "Call",
      "Meeting": "Meeting",
      "Task": "Task",
      "WhatsApp": "WhatsApp",
      "Email": "Email",
      "Demo": "Demo",
      "FollowUp": "Follow-up",
      "Note": "Note"
    },
    "sources": {
      "Site": "Website",
      "Manual": "Manual",
      "Formulário": "Form",
      "WhatsApp": "WhatsApp",
      "Importação": "Import",
      "Indicação": "Referral"
    },
    "loadError": "Error loading leads. Please try again."
  },
  "inbox": {
    "title": "Inbox",
    "subtitle": "Omnichannel conversation hub",
    "boxLabel": "Box",
    "box": "Box",
    "boxAll": "all",
    "boxInboxPrincipal": "Main inbox",
    "searchPlaceholderLong": "Search conversation, name or number...",
    "tabAll": "All",
    "tabUnread": "Unread",
    "emptyNoChannelsTitle": "Your inbox is ready",
    "emptyNoChannelsDesc": "Connect a channel to get started: Instagram, WhatsApp, Facebook, Telegram or Webchat.",
    "emptyNoConversationsTitle": "No conversations yet",
    "emptyNoConversationsDesc": "When someone sends a message, it will appear here in real time.",
    "emptyNoConversationsChannel": "No {{channel}} conversations yet.",
    "ctaViewChannels": "View channels",
    "ctaManageChannels": "Manage channels",
    "ctaConnectChannel": "Connect channel",
    "emptyChatTitle": "Select a conversation",
    "emptyChatDescription": "Messages will appear here in real time.",
    "noMessagesYet": "No messages yet",
    "newMessagesCount": "{{count}} new message(s)",
    "goToBottom": "Go to bottom",
    "resend": "Resend",
    "pickEmoji": "Pick an emoji",
    "emojiRecent": "Recent",
    "emojiSmileys": "Smileys & people",
    "emojiGestures": "Gestures",
    "emojiHearts": "Hearts & emotion",
    "emojiObjects": "Objects",
    "emojiNature": "Nature",
    "emojiFood": "Food",
    "emojiNoRecent": "No emojis used yet",
    "attachComingSoon": "Attachments coming soon",
    "conversationClosed": "Conversation closed",
    "assignComingSoon": "Assign coming soon",
    "moreActions": "More actions",
    "whatsapp": {
      "windowActiveUntil": "Window active until {{date}}",
      "windowExpired": "Window expired",
      "windowExpiredUseTemplate": "Window expired. Send a template to continue.",
      "outsideWindowHint": "Outside the 24h window. To message this contact, send a Utility/Auth template (costs 1 credit).",
      "tabMessage": "Message",
      "tabTemplate": "Template",
      "tabAttachment": "Attachment",
      "creditsLabel": "Credits",
      "noCredits": "Insufficient balance. Buy credits to send templates.",
      "lowCredits": "Low balance. Buy more credits.",
      "buyCredits": "Buy credits",
      "selectTemplate": "Select a template",
      "templateCost": "Cost: 1 credit",
      "templateSent": "Template sent",
      "insufficientCreditsTitle": "Insufficient balance",
      "insufficientCreditsDesc": "You need credits to send templates and open new windows."
    },
    "filterApplied": "Filter: {{filter}}",
    "createLeadComingSoon": "Create lead coming soon",
    "createDealComingSoon": "Create deal coming soon",
    "noInbox": "No inbox",
    "configureChannels": "Configure channels",
    "filters": "Filters",
    "channel": "Channel",
    "all": "all",
    "status": "Status",
    "statusAll": "all",
    "statusNew": "new",
    "statusInProgress": "in progress",
    "statusResolved": "resolved",
    "responsible": "Responsible",
    "responsibleAll": "all",
    "responsibleMe": "me",
    "responsibleCompany": "company users",
    "unreadOnly": "unread only",
    "mockState": "Mock state:",
    "conversations": "Conversations",
    "searchPlaceholder": "Search conversation…",
    "unreadCount": "{{count}} unread",
    "noChannelsTitle": "Connect your channels to get started",
    "noChannelsDescription": "Enable Webchat, WhatsApp or Instagram to receive messages here.",
    "noConversationsTitle": "No conversations yet",
    "noConversationsDescription": "Install Webchat on your site or connect WhatsApp",
    "selectConversation": "Select a conversation to get started",
    "viewDeal": "View deal",
    "createDeal": "Create deal",
    "more": "More",
    "viewContact": "View contact",
    "createContact": "Create contact",
    "viewLead": "View lead",
    "createLead": "Create lead",
    "crm": "CRM",
    "timeNow": "Now",
    "timeMinutes": "{{count}} min",
    "noValue": "—",
    "channelNeedsReconnect": "Channel needs to reconnect.",
    "errorSending": "Error sending.",
    "assignResponsible": "Assign responsible",
    "markResolved": "Mark as resolved",
    "addTags": "Add tags",
    "viewDetails": "View details",
    "details": "Details",
    "conversationStarted": "Conversation started — waiting for first message",
    "today": "Today",
    "sending": "sending…",
    "failedRetry": "failure · retry",
    "download": "Download",
    "image": "Image",
    "whatsapp24h": "Respect the 24h window when applicable",
    "attach": "Attach",
    "send": "Send",
    "couldNotLoad": "Could not load conversations",
    "retry": "Reload",
    "threadNoIdFallback": "Thread has no id (awaiting backend fix)",
    "threadNoIdFallbackHint": "This conversation does not have an id on the server yet. Click Reload when the backend is updated.",
    "modalMockMessage": "Mock modal — integration in a later phase.",
    "close": "Close",
    "salesCopilotTitle": "Sales Copilot\nAI that summarizes conversations and suggests next steps.\nComing soon.",
    "channelWebchat": "Webchat",
    "channelWhatsapp": "WhatsApp",
    "channelInstagram": "Instagram",
    "channelMessenger": "Messenger",
    "channelTelegram": "Telegram",
    "channelLinkedin": "LinkedIn",
    "reply": "Reply…",
    "replyWhatsapp": "Reply via WhatsApp…",
    "replyInstagram": "Reply via Instagram…",
    "replyMessenger": "Reply via Messenger…",
    "replyTelegram": "Reply via Telegram…",
    "replyWebchat": "Reply via Webchat…",
    "replyLinkedin": "Reply via LinkedIn…",
    "tabInstagram": "Instagram",
    "tabWhatsApp": "WhatsApp",
    "emptySidebarTitle": "Your inbox is ready",
    "emptySidebarDescription": "Connect a channel to get started: Instagram, WhatsApp, Facebook, Telegram or Webchat.",
    "connectChannel": "Connect channel",
    "assign": "Assign",
    "closeConversation": "Close conversation",
    "messagePlaceholder": "Type your message...",
    "contact": "Contact",
    "info": "Information",
    "firstContactAt": "First contact on",
    "lastMessageAt": "Last message",
    "conversationStatus": "Conversation status",
    "statusOpen": "Open",
    "statusAssigned": "Assigned",
    "statusClosed": "Closed",
    "markAsRead": "Mark as read",
    "actions": "Actions",
    "inboxPrincipal": "Main Inbox",
    "tabFacebook": "Facebook",
    "tabTelegram": "Telegram",
    "tabWebchat": "Webchat",
    "ctaAddChannel": "Add channel",
    "ctaTestWebchat": "Test Webchat",
    "channelConnected": "{{channel}} connected",
    "channelDisconnected": "{{channel}} not connected",
    "emoji": "Emoji",
    "mock": {
      "nameJoao": "John Smith",
      "nameMaria": "Mary Johnson",
      "namePedro": "Peter Brown",
      "nameCarla": "Carol Davis",
      "nameAna": "Ann Cooper",
      "nameRicardo": "Richard Wilson",
      "lastThanks": "Thanks for getting back!",
      "lastEnterprise": "Hi, I'd like to know about the enterprise plan.",
      "lastCallWeek": "Can we schedule a call this week?",
      "lastDocument": "I sent the document in the group.",
      "lastQuote": "I need a quote urgently.",
      "lastPartnership": "Thank you for the partnership opportunity.",
      "yesterday": "Yesterday",
      "tagVip": "VIP",
      "tagFollowUp": "Follow-up",
      "tagB2b": "B2B",
      "msgHelloPlan": "Hi, I'd like to know about the enterprise plan.",
      "msgHelloSize": "Hi Maria! Sure, what's the size of your company?",
      "msgFifty": "We're around 50 people.",
      "msgPhoto": "Here's a photo of our office for you.",
      "msgGreatDoc": "Great! Sending the document with the benefits.",
      "msgThanksReceived": "Thanks! I already received it.",
      "fileNameBenefits": "Benefits-Enterprise-Plan.pdf"
    }
  },
  "pipeline": {
    "title": "Pipeline",
    "selectPipeline": "Select pipeline",
    "favoritesLimitReached": "You can have at most 3 favorites.",
    "addFavorite": "Add to favorites",
    "removeFavorite": "Remove from favorites",
    "removeFavoriteError": "Could not remove from favorites. Please try again.",
    "defaultBadge": "Default",
    "setAsDefault": "Set as default",
    "removeDefault": "Remove default",
    "searchPlaceholder": "Search deals…",
    "newDeal": "New Deal",
    "viewKanban": "Kanban view",
    "viewList": "List view",
    "filterByStatus": "Filter deals by status",
    "inPipeline": "in pipeline",
    "deals": "deals",
    "winRate": "Win rate",
    "won": "won",
    "lost": "lost",
    "closed": "Closed",
    "dealsCount": "{{count}} deals",
    "dragDealHere": "Drag a deal to this stage",
    "noClosedInFilter": "No closed deals in this filter",
    "wonBadge": "Won",
    "lostBadge": "Lost",
    "allStages": "All stages",
    "allResponsibles": "All owners",
    "tableDeal": "Deal",
    "tableCompany": "Company",
    "tableValue": "Value",
    "tableStage": "Stage",
    "tableResponsible": "Owner",
    "tableLastActivity": "Last activity",
    "tableCreatedAt": "Created at",
    "tableActions": "Actions",
    "editDeal": "Edit deal",
    "deleteDeal": "Delete deal",
    "edit": "Edit",
    "delete": "Delete",
    "moveToStage": "Move to another stage",
    "noDealsFound": "No deals found",
    "adjustFilters": "Try adjusting your search filters",
    "paginatorTemplate": "Showing {first} to {last} of {totalRecords} deals",
    "moveTo": "Move to",
    "deleteModal": {
      "title": "Confirm Delete",
      "message": "Are you sure you want to delete the deal",
      "permanent": "This action cannot be undone.",
      "deleting": "Deleting..."
    },
    "markAsLostModal": {
      "title": "Mark as lost",
      "dealLabel": "Deal:",
      "selectReason": "Select the loss reason (from your company):",
      "loadingReasons": "Loading reasons...",
      "selectReasonPlaceholder": "Select reason",
      "saving": "Saving..."
    },
    "statusFilter": {
      "title": "Deal Status",
      "inProgress": "In progress",
      "clear": "Clear"
    },
    "drawer": {
      "newDeal": "New Deal",
      "pipelineLabel": "Pipeline:",
      "stageLabel": "Stage:",
      "dealTitle": "Deal Title",
      "companyOrLead": "Company or Lead",
      "searchCompanyOrLead": "Search company or lead...",
      "value": "Value",
      "expectedCloseDate": "Expected Close Date",
      "stage": "Stage",
      "responsible": "Owner",
      "cancel": "Cancel",
      "createDeal": "Create Deal",
      "creating": "Creating…",
      "searching": "Searching...",
      "noResults": "No results found",
      "organization": "Company",
      "person": "Person"
    },
    "drawerNewPipeline": {
      "titleNew": "New Pipeline",
      "titleEdit": "Edit Pipeline",
      "nameLabel": "Pipeline Name",
      "namePlaceholder": "E.g. Commercial Brazil – SaaS",
      "description": "Description",
      "descriptionPlaceholder": "Describe the purpose or type of deals for this pipeline…",
      "useDefaultStages": "Use default stages",
      "stagesLabel": "Pipeline Stages",
      "customStages": "Custom stages",
      "customStagePlaceholder": "Custom stage name",
      "addStage": "Add stage",
      "default": "Default",
      "cancel": "Cancel",
      "createPipeline": "Create Pipeline",
      "saveChanges": "Save Changes",
      "creating": "Creating..."
    },
    "modal": {
      "stage": "Stage",
      "selectStage": "Select a stage",
      "valueTotal": "Total Value",
      "probability": "Probability",
      "status": "Status",
      "summary": "Summary",
      "addSummary": "Add summary",
      "mainInfo": "Main information",
      "dealDetails": "Deal details",
      "customFields": "Custom fields",
      "manageFields": "Manage fields",
      "noCustomFields": "No custom fields have been created for this pipeline.",
      "createdAt": "Created at",
      "closeIn": "Closes on",
      "nextStageSuggested": "Suggested next stage:",
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "close": "Close",
      "save": "Save",
      "saving": "Saving...",
      "cancel": "Cancel",
      "activities": "Activities",
      "newActivity": "New Activity",
      "noActivities": "No activities recorded",
      "noActivitiesHint": "Record calls, messages, notes and next steps for this deal.",
      "createFirstActivity": "Create first activity",
      "winDeal": "Win Deal",
      "loseDeal": "Lose Deal",
      "backStage": "Back stage",
      "nextStage": "Next stage",
      "saveChanges": "Save Changes",
      "call": "Call",
      "email": "Email",
      "whatsApp": "WhatsApp",
      "opening": "Opening...",
      "note": "Note",
      "attachment": "Attachment",
      "noDescriptionYet": "No description added yet.",
      "summaryPlaceholder": "Briefly describe the current context of this deal...",
      "titleLabel": "Title",
      "valueLabel": "Value",
      "origin": "Origin",
      "selectOrigin": "Select an origin",
      "expectedCloseDate": "Expected close date",
      "dealInfoTab": "Deal Information",
      "originTab": "Origin",
      "responsible": "Responsible",
      "relatedCompany": "Related company",
      "noCompanyLinked": "No company linked.",
      "relationshipContacts": "Relationship (Contacts)",
      "contacts": "Contacts",
      "noContactsLinked": "No contacts linked.",
      "customFieldsTitle": "Custom fields",
      "attachments": "Attachments",
      "addFile": "Add file",
      "attach": "Attach",
      "uploading": "Uploading...",
      "allowedFormats": "Allowed formats: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, RTF (max. 5MB)",
      "loadingAttachments": "Loading attachments...",
      "noAttachmentsYet": "No attachments added yet.",
      "deleteFile": "Delete file",
      "proposals": "Proposals",
      "newProposal": "New Proposal",
      "proposalApproved": "Proposal Approved",
      "proposalApprovedHint": "This deal has an approved proposal. Create, edit and resend actions are disabled.",
      "loadingProposals": "Loading proposals...",
      "noProposalsYet": "No proposals created yet.",
      "createdOn": "Created on",
      "viewDetails": "View details",
      "downloadPdf": "Download PDF",
      "sendByEmail": "Send by email",
      "sendProposalDisabledRejected": "Cannot send rejected proposal.",
      "sendProposalDisabledApproved": "Cannot send. An approved proposal already exists.",
      "selectPlaceholder": "Select",
      "activityFormTitle": "New Activity",
      "typeLabel": "Type",
      "textLabel": "Text",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "channelLabel": "Channel",
      "descriptionOptional": "Description (optional)",
      "followUpDescriptionPlaceholder": "Follow-up description...",
      "taskTitlePlaceholder": "E.g. Prepare commercial proposal",
      "taskDueDateLabel": "Due date",
      "taskDescriptionPlaceholder": "Task description...",
      "meetingDescriptionPlaceholder": "Meeting description...",
      "callDescriptionPlaceholder": "Record call details...",
      "subjectLabel": "Subject",
      "emailSubjectPlaceholder": "Email subject",
      "emailContentPlaceholder": "Email content...",
      "templateLabel": "Template",
      "messageLabel": "Message",
      "loadingTemplates": "Loading...",
      "freeMessageOption": "Free message (no template)",
      "messageEditablePlaceholder": "Message (editable)...",
      "messagePlaceholder": "Type your message to the client...",
      "previewAsClient": "Preview (as client will see):",
      "openWhatsApp": "Open WhatsApp",
      "fileLabel": "File",
      "createdBy": "Created by",
      "userDefault": "User",
      "notePlaceholder": "Note important points from the conversation, next steps or observations...",
      "sendProposalTitle": "Send Proposal",
      "clientEmailLabel": "Client Email",
      "clientEmailPlaceholder": "client@example.com",
      "send": "Send",
      "customFieldsOrderTitle": "Order custom fields",
      "customFieldsOrderDescription": "Adjust the order and visibility of custom fields for this pipeline.",
      "useArrowsHint": "Use the arrow buttons to change the order of fields.",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "noFieldsConfigured": "No custom fields configured for this pipeline.",
      "callModalTitle": "Call",
      "callAutoRecordHint": "Call will be recorded automatically in history",
      "phoneLabel": "Phone",
      "phonePlaceholder": "(00) 00000-0000",
      "startCall": "Start call",
      "callInProgress": "Call in progress...",
      "endCall": "End",
      "resultLabel": "Result",
      "resultAnswered": "Answered",
      "resultNoAnswer": "No answer",
      "resultVoicemail": "Voicemail",
      "resultBusy": "Busy",
      "observationLabel": "Notes",
      "observationPlaceholder": "Add notes about the call...",
      "durationLabel": "Duration:",
      "emailModalTitle": "Send Email",
      "toLabel": "To",
      "toPlaceholder": "recipient@example.com",
      "aiHelpLabel": "✨ Help to write",
      "themeOptionalLabel": "Theme (optional)",
      "themePlaceholder": "E.g. Product X presentation",
      "generateText": "Generate text",
      "generating": "Generating...",
      "replaceConfirmTitle": "Replace current message?",
      "replace": "Replace",
      "append": "Append to end",
      "suggestedText": "✨ Suggested text",
      "generateAgain": "Generate again",
      "messagePlaceholderEmail": "Type your message...",
      "noteModalTitle": "New Note",
      "attachmentModalTitle": "Attach File",
      "selectedFileLabel": "Selected file:",
      "proposalStatusDraft": "Draft",
      "proposalStatusSent": "Sent",
      "proposalStatusViewed": "Viewed",
      "proposalStatusApproved": "Approved",
      "proposalStatusRejected": "Rejected",
      "proposalStatusExpired": "Expired",
      "statusOpen": "Open",
      "statusWon": "Won",
      "statusLost": "Lost",
      "channelCall": "Call",
      "channelEmail": "Email",
      "channelWhatsApp": "WhatsApp",
      "manualSuffix": "(Manual)",
      "digitePlaceholder": "Enter ",
      "activityTypeNote": "Note",
      "activityTypeFollowUp": "Follow-up",
      "activityTypeTask": "Task",
      "activityTypeMeeting": "Meeting",
      "activityTypeCallManual": "Call (Manual)",
      "activityTypeEmailManual": "Email (Manual)",
      "activityTypeWhatsAppManual": "WhatsApp (Manual)",
      "activityTypeAttachmentManual": "Attachment (Manual)",
      "optional": "optional",
      "activityDefault": "Activity"
    }
  },
  "proposals": {
    "newDrawer": {
      "titleNew": "New Proposal",
      "titleEdit": "Edit Proposal",
      "linkedTo": "Proposal linked to",
      "selectDeal": "Select a deal",
      "clientAutoHint": "Client will be automatically filled with the deal's client",
      "titleLabel": "Title",
      "titlePlaceholder": "Enter the proposal title",
      "templateLabel": "Proposal Template",
      "loadingTemplates": "Loading templates...",
      "itemsLabel": "Proposal Items",
      "addItem": "Add Item",
      "noItemsHint": "No items added. Click 'Add Item' to start.",
      "product": "Product",
      "qty": "Qty",
      "unitPrice": "Unit",
      "total": "Total",
      "select": "Select",
      "removeItem": "Remove item",
      "withinRange": "Within range",
      "outOfRange": "Out of range",
      "adjustmentsRecorded": "Adjustments recorded",
      "pricingReasonLabel": "Reason for adjustment",
      "pricingReasonPlaceholder": "Explain the reason for the price adjustment...",
      "totalLabel": "Total:",
      "valueLabel": "Proposal Value",
      "autoCalculateLabel": "Generate value automatically from items",
      "validUntilLabel": "Proposal validity",
      "internalNotesLabel": "Internal notes",
      "internalNotesPlaceholder": "Add internal notes about this proposal...",
      "attachmentsLabel": "Attachments",
      "attach": "Attach",
      "uploading": "Uploading...",
      "allowedFormats": "Allowed formats: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, RTF, images (max. 10MB)",
      "selectedFiles": "Selected files:",
      "removeFile": "Remove file",
      "loadingAttachments": "Loading attachments...",
      "noAttachmentsYet": "No attachments added yet.",
      "deleteFile": "Delete file",
      "cancel": "Cancel",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "createProposal": "Create Proposal"
    }
  },
  "pipelines": {
    "title": "Pipelines",
    "subtitle": "Manage your company's sales pipelines",
    "registerPipeline": "Register Pipeline",
    "searchPlaceholder": "Search pipelines...",
    "search": "Search",
    "loading": "Loading pipelines...",
    "emptyTitle": "No pipelines found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first pipeline",
    "tableName": "Name",
    "tableStages": "Stages",
    "tableDeals": "Deals",
    "tableStatus": "Status",
    "tableActions": "Actions",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "editPipeline": "Edit pipeline",
    "copyPipeline": "Copy pipeline",
    "deletePipeline": "Delete pipeline",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} pipelines",
    "deleteModal": {
      "title": "Delete Pipeline",
      "message": "Are you sure you want to delete the pipeline",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "copyModal": {
      "title": "Duplicate Pipeline",
      "message": "Enter a name for the copied pipeline. The system will ensure the name is unique.",
      "nameLabel": "Pipeline Name",
      "namePlaceholder": "Name of the copied pipeline",
      "cancel": "Cancel",
      "duplicate": "Duplicate"
    },
    "drawer": {
      "titleNew": "New Pipeline",
      "titleEdit": "Edit Pipeline",
      "subtitle": "Configure the sales pipeline",
      "nameLabel": "Pipeline Name",
      "namePlaceholder": "E.g. Main Pipeline",
      "description": "Description",
      "descriptionPlaceholder": "Pipeline description (optional)",
      "active": "Active",
      "restrictByRole": "Restrict access by Role",
      "restrictByRoleHint": "Select the roles that can see this pipeline. If none are selected, all users will be able to see it.",
      "loadingRoles": "Loading roles...",
      "noRoles": "No roles available.",
      "rolesSelected": "{{count}} role(s) selected",
      "stages": "Stages",
      "stagesDefaultEditable": "Stages (Default Editable)",
      "add": "Add",
      "noStagesHint": "No stages added. Click \"Add\" to create stages.",
      "cannotDeleteStagesWarning": "⚠️ Attention: This pipeline has associated deals. You cannot delete stages, but you can add new stages, edit names and probabilities.",
      "stageNamePlaceholder": "Stage name",
      "defaultStageQualification": "Qualification",
      "defaultStageProposal": "Proposal",
      "defaultStageNegotiation": "Negotiation",
      "defaultStageClosing": "Closing",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "removeStage": "Remove stage",
      "cannotRemoveStageTitle": "Cannot remove stages when the pipeline has associated deals",
      "cancel": "Cancel",
      "saveChanges": "Save Changes",
      "register": "Register",
      "saving": "Saving...",
      "nameRequired": "Pipeline name is required.",
      "stagesMinOne": "Add at least one stage.",
      "stagesAllMustHaveName": "All stages must have a name."
    }
  },
  "lostReasons": {
    "title": "Lost Reasons",
    "subtitle": "Configure the reasons shown when a deal is marked as \"Lost\".",
    "registerReason": "Register Reason",
    "searchPlaceholder": "Search reasons...",
    "search": "Search",
    "loading": "Loading lost reasons...",
    "emptyTitle": "No lost reasons found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first lost reason",
    "tableName": "Name",
    "tableDescription": "Description",
    "tableCategory": "Category",
    "tableActions": "Actions",
    "editReason": "Edit reason",
    "deleteReason": "Delete reason",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} reasons",
    "deleteModal": {
      "title": "Delete Lost Reason",
      "message": "Are you sure you want to delete the reason",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "drawer": {
      "titleNew": "New Lost Reason",
      "titleEdit": "Edit Lost Reason",
      "subtitle": "Configure the lost reason",
      "nameLabel": "Reason Name",
      "namePlaceholder": "E.g. Price too high",
      "category": "Category",
      "description": "Description",
      "descriptionPlaceholder": "Detailed description of the lost reason (optional)",
      "cancel": "Cancel",
      "saveChanges": "Save Changes",
      "register": "Register",
      "saving": "Saving..."
    },
    "categories": {
      "Price": "Price",
      "Competition": "Competition",
      "Timing": "Timing",
      "Fit": "Fit",
      "Internal": "Internal",
      "Other": "Other"
    }
  },
  "marketing": {
    "tags": {
      "title": "Tags",
      "subtitle": "Organize contacts, companies and deals to segment campaigns.",
      "newTag": "New tag",
      "searchPlaceholder": "Search tag…",
      "filterAll": "All",
      "filterActive": "Active",
      "filterInactive": "Inactive",
      "tableTag": "Tag",
      "tableDescription": "Description",
      "tableUsage": "Usage",
      "tableStatus": "Status",
      "tableActions": "Actions",
      "paginatorReport": "Showing {first} to {last} of {totalRecords} tags",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "edit": "Edit",
      "viewUsage": "View usage",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "emptyTitle": "No tags created yet",
      "emptyWithFilters": "Adjust filters to see results.",
      "emptyNoFilters": "Create tags to organize contacts, companies and deals.",
      "tooltipEdit": "Edit tag",
      "tooltipViewUsage": "View tag usage",
      "tooltipDeactivate": "Deactivate tag",
      "tooltipActivate": "Activate tag",
      "tooltipCreateSegment": "Create segment with this tag",
      "usageTooltipDetail": "Used in:\n• People: {{people}}\n• Companies: {{organizations}}\n• Deals: {{deals}}",
      "usageTooltipNone": "This tag is not being used yet.",
      "modalPreview": "Preview",
      "modalNameMax": "max 40 characters",
      "modalDescMax": "max 300 characters",
      "tableCreatedAt": "Created at",
      "modalCreateTitle": "New tag",
      "modalEditTitle": "Edit tag",
      "modalSubtitle": "Name, color and description to identify the tag in lists.",
      "modalFooterHint": "You can change this later.",
      "modalCreateButton": "Create tag",
      "modalName": "Name",
      "modalNamePlaceholder": "E.g. VIP Customer",
      "modalNameHelper": "This name is shown in lists and when segmenting campaigns.",
      "modalColor": "Color",
      "modalColorDefault": "Default",
      "modalDescription": "Description",
      "modalDescriptionPlaceholder": "Description (optional)",
      "modalPreviewDefaultName": "VIP CUSTOMER",
      "usageTitle": "Tag usage",
      "usagePeople": "People",
      "usageOrganizations": "Organizations",
      "usageDeals": "Deals",
      "createSegmentFromTag": "Create segment with this tag",
      "closeUsageModal": "Close tag usage modal",
      "loading": "Loading…",
      "tryAgain": "Try again",
      "nameRequired": "Name is required.",
      "tagCreated": "Tag created.",
      "tagUpdated": "Tag updated.",
      "tagActivated": "Tag activated.",
      "tagDeactivated": "Tag deactivated.",
      "statusChangeError": "Could not change the status.",
      "errorDuplicate": "A tag with this name already exists.",
      "errorSave": "Error saving. Please try again.",
      "confirmModal": {
        "titleDeactivate": "Deactivate tag?",
        "messageDeactivate": "The tag \"{{name}}\" will no longer be available for use in segments and campaigns. You can activate it again later.",
        "titleActivate": "Activate tag?",
        "messageActivate": "The tag \"{{name}}\" will be available again for use in segments and campaigns.",
        "cancel": "Cancel",
        "deactivate": "Deactivate",
        "activate": "Activate",
        "processing": "Processing…"
      }
    },
    "segments": {
      "title": "Segments",
      "subtitle": "Create smart lists for email campaigns.",
      "newSegment": "New segment",
      "searchPlaceholder": "Search…",
      "filterType": "Type",
      "selectTypePlaceholder": "Select a type to segment",
      "typePeople": "People",
      "typeOrganizations": "Organizations",
      "typeDeals": "Deals",
      "filterActive": "Active",
      "filterInactive": "Inactive",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "tableName": "Name",
      "tableType": "Type",
      "tableEstimate": "Estimate",
      "tableStatus": "Status",
      "tableActions": "Actions",
      "updatedAt": "Updated at",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "createCampaign": "Create campaign",
      "emptyTitle": "No segments found",
      "emptyNoFilters": "Create your first segment to run email campaigns.",
      "estimate": "Estimate",
      "destinations": "recipients",
      "paginatorReport": "Showing {first} to {last} of {totalRecords} segments",
      "estimateNow": "Estimate now",
      "saveSegment": "Save segment",
      "back": "Back",
      "nameRequired": "Name is required.",
      "saved": "Segment saved.",
      "created": "Segment created.",
      "includeAny": "Include (any)",
      "includeAll": "Include (all)",
      "exclude": "Exclude",
      "onlyValidEmail": "Only with valid email",
      "segmentName": "Segment name",
      "segmentNameRequired": "Segment name is required.",
      "segmentTypeRequired": "Select a type to segment.",
      "segmentNamePlaceholder": "E.g. Leads Fair 2026",
      "segmentNameMax": "max 60 characters",
      "modalTitleNew": "New segment",
      "modalTitleEdit": "Edit segment",
      "modalSubtitle": "Create smart lists for email campaigns.",
      "configAndRules": "Configuration and Rules",
      "configSegmentTitle": "Segment configuration",
      "preview": "Preview",
      "previewClickEstimate": "Click \"Estimate now\" to see the estimate.",
      "previewInitial": "Preview will update automatically as you define the rules.",
      "previewEstimating": "Calculating estimate…",
      "previewEstimateLabel": "Estimate",
      "previewEstimateHint": "The estimate considers segment rules. Unsubscribed contacts will be filtered on send.",
      "previewError": "Could not calculate estimate. Please try again.",
      "previewTooLarge": "Segment too large. Refine rules to stay within campaign limit.",
      "onlyValidEmailTooltip": "Recommended for email campaigns.",
      "onlyValidEmailDisabledHint": "Available only for People or Organization segments.",
      "tagsBlockLabel": "Tags",
      "tagsBlockIntro": "Use tags to define which records should be included or excluded from this segment.",
      "filtersSectionLabel": "Filters",
      "filtersSectionIntro": "Define which records are included or excluded from this segment.",
      "includeRegistersTitle": "Include records",
      "includeRegistersSubtitle": "Contacts that have any of these tags",
      "includeRegistersHint": "Contacts that have any of these tags.",
      "excludeRegistersTitle": "Exclude records",
      "excludeRegistersSubtitle": "Contacts that have these tags",
      "excludeRegistersHint": "Contacts that have these tags will be removed from the segment.",
      "optionsSectionLabel": "Options",
      "registros": "records",
      "previewSubtitlePeople": "People that match the defined rules.",
      "previewSubtitleOrgs": "Companies that match the defined rules.",
      "previewSubtitleDeals": "Deals that match the defined rules.",
      "previewSubtitleAuto": "Updated automatically",
      "previewZero": "No contacts match the current rules.",
      "includeTagsLabel": "Include contacts that have these tags",
      "includeTagsHint": "(any of these tags)",
      "includeTagsTooltip": "Contacts that have any of these tags will be included in the segment.",
      "excludeTagsLabel": "Exclude contacts that have these tags",
      "excludeTagsTooltip": "Contacts with these tags will be removed from the segment.",
      "addTag": "Add tag",
      "addTagPlaceholder": "+ add tag",
      "searchTagPlaceholder": "Search tag…",
      "noTagsInList": "No tags found.",
      "removeTag": "Remove tag",
      "closeModal": "Close modal",
      "discardConfirmTitle": "Discard changes?",
      "discardConfirmMessage": "You have unsaved changes. Discard them?",
      "discardConfirmCancel": "Keep editing",
      "discardConfirmDiscard": "Discard",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "segmentSaved": "Segment saved.",
      "segmentDuplicated": "Segment duplicated.",
      "duplicateError": "Error duplicating segment.",
      "segmentActivated": "Segment activated.",
      "segmentDeactivated": "Segment deactivated.",
      "statusChangeError": "Could not change the status.",
      "loading": "Loading…",
      "tryAgain": "Try again"
    },
    "templates": {
      "title": "Templates",
      "subtitle": "Create reusable messages for campaigns.",
      "newTemplate": "New template",
      "searchPlaceholder": "Search by name…",
      "filterActive": "Active",
      "filterInactive": "Inactive",
      "filterAll": "All",
      "cardSubject": "Subject",
      "lastUpdate": "Last update",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "preview": "Preview",
      "test": "Test",
      "emptyTitle": "No templates found",
      "emptyNoFilters": "Create a template to speed up your campaigns.",
      "emptyWithFilters": "No results with the current filters.",
      "save": "Save",
      "sendTest": "Send test",
      "variables": "Variables",
      "copyVariable": "Copy",
      "loading": "Loading…",
      "tryAgain": "Try again",
      "tableType": "Type",
      "tableName": "Name",
      "tablePreview": "Preview",
      "tableStatus": "Status",
      "tableActions": "Actions",
      "typeEmail": "Email",
      "typeWhatsapp": "WhatsApp",
      "whatsappEditHint": "WhatsApp templates are edited in Settings.",
      "whatsappDuplicateHint": "Duplicate WhatsApp template coming soon.",
      "whatsappToggleHint": "Activate/deactivate WhatsApp template coming soon.",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "paginatorReport": "Showing {first} to {last} of {totalRecords} templates",
      "createModalTitle": "Create template",
      "createModalSubtitle": "Set the name and base for the template.",
      "createChannelTitle": "Create a unique campaign from scratch.",
      "channelEmail": "Email",
      "channelSms": "SMS",
      "channelWhatsapp": "WhatsApp",
      "channelPush": "Push",
      "channelComingSoon": "Coming soon",
      "channelLabel": "Channel",
      "baseLabel": "Base",
      "createStep1Title": "Configuration",
      "createStep2Title": "Template base",
      "createReviewTitle": "Review",
      "namePlaceholder": "E.g. Welcome, Newsletter",
      "startBlank": "Start blank",
      "useModel": "Use model",
      "blankTemplateInfo": "You will create a blank template and can edit it in the next step.",
      "createButton": "Create",
      "continue": "Continue",
      "back": "Back",
      "closeCreateModal": "Close template creation modal",
      "templateNameRequired": "Template name is required.",
      "templateCreated": "Template created.",
      "templateServiceUnavailable": "Template service unavailable. Verify the backend is configured (POST /api/marketing/templates).",
      "templateCreateError": "Error creating template. Please try again.",
      "templateDuplicated": "Template duplicated.",
      "duplicateError": "Error duplicating.",
      "templateActivated": "Template activated.",
      "templateDeactivated": "Template deactivated.",
      "statusChangeError": "Could not change the status.",
      "blockHeader": "Header",
      "blockText": "Text",
      "blockButton": "Button",
      "blockImage": "Image",
      "blockDivider": "Divider",
      "blockFooter": "Footer",
      "blockDescHeader": "Title + subtitle",
      "blockDescText": "Paragraph / list",
      "blockDescButton": "CTA",
      "blockDescImage": "Banner",
      "blockDescDivider": "Separator",
      "blockDescFooter": "Contact + links",
      "blocksTitle": "Blocks",
      "blocksIntro": "Click to add at the end.",
      "searchBlock": "Search block…",
      "quickSuggestions": "Quick suggestions",
      "modelBoasVindas": "Welcome",
      "modelFollowUp": "Follow-up",
      "modelNewsletter": "Simple newsletter",
      "modelPromo": "Simple promo",
      "modelAtualizacaoProduto": "Product update",
      "modelConfirmacao": "Confirmation",
      "emptyCanvasTitle": "Start your template",
      "emptyCanvasText": "Choose a block on the left or use a ready-made model.",
      "addHeader": "Add header",
      "addText": "Add text",
      "templateEditorTitle": "Template",
      "statusDraft": "Draft",
      "checklistTitle": "Quality checklist",
      "checklistFooter": "Has footer",
      "checklistCta": "Has button/CTA",
      "checklistLinks": "Valid links",
      "checklistAlt": "Images with alt text",
      "templateSettings": "Template settings",
      "widthDesktop": "Desktop",
      "widthMobile": "Mobile",
      "propertiesHint": "Tip: click a block on the canvas to edit content and style.",
      "duplicateBlock": "Duplicate block",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "removeBlock": "Remove",
      "previewSubject": "Subject",
      "previewPreheader": "Preheader",
      "canvasTitle": "Canvas",
      "propertiesTitle": "Properties",
      "visualMode": "Visual",
      "htmlMode": "HTML",
      "previewTitle": "Preview",
      "previewDesktop": "Desktop",
      "previewMobile": "Mobile",
      "sendTestTitle": "Send test",
      "sendTestEmail": "Destination email",
      "sendTestButton": "Send"
    },
    "campaigns": {
      "title": "Email campaigns",
      "subtitle": "Send segmented campaigns to your contacts.",
      "newCampaign": "New campaign",
      "searchPlaceholder": "Search…",
      "search": "Search",
      "filterStatus": "Status",
      "statusDraft": "Draft",
      "statusScheduled": "Scheduled",
      "statusRunning": "Sending",
      "statusPaused": "Paused",
      "statusCompleted": "Sent",
      "statusCancelled": "Cancelled",
      "statusFailed": "Failed",
      "tableName": "Name",
      "tableStatus": "Status",
      "tableSegment": "Segment",
      "tableTemplate": "Template",
      "tableSchedule": "Schedule",
      "tableProgress": "Progress",
      "tableSent": "Sent",
      "tableEnvios": "Sends",
      "tableCreatedAt": "Created at",
      "tableActions": "Actions",
      "listRecipients": "Recipients",
      "listOpens": "Opens",
      "listClicks": "Clicks",
      "listUnsubscribed": "Unsubscribed",
      "listSent": "Sent",
      "listFailed": "Failed",
      "listSkipped": "Skipped",
      "listSentAt": "Sent on",
      "listStartedAt": "Started on",
      "listScheduledAt": "Scheduled for",
      "tableFailed": "Failed",
      "tableSkipped": "Skipped",
      "emptyTitle": "No campaigns found",
      "emptyNoFilters": "Create your first campaign.",
      "paginatorReport": "Showing {first} to {last} of {totalRecords} campaigns",
      "loading": "Loading…",
      "tryAgain": "Try again",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "viewReport": "View report",
      "archive": "Archive",
      "wizardTitle": "Create campaign",
      "wizardSubtitle": "Configure and send your email campaign.",
      "step1Title": "Campaign configuration",
      "step2Title": "Choose audience",
      "step3Title": "Choose email template",
      "step4Title": "Review and send",
      "campaignName": "Campaign name",
      "emailSubject": "Email subject",
      "preheader": "Preheader (optional)",
      "preheaderHint": "Shows after subject in inbox.",
      "senderName": "Sender name",
      "senderEmail": "Sender email",
      "senderBlockTitle": "Sender",
      "loadingSender": "Loading sender…",
      "senderConfiguredHint": "This email is configured in your company's sending settings.",
      "senderDefaultHint": "You are using Pipeup's default sending. We recommend configuring your domain for better deliverability.",
      "senderChangeConfig": "Change settings",
      "senderConfigureSmtp": "Configure SMTP",
      "closeWizard": "Close campaign wizard",
      "senderNamePlaceholder": "E.g. Ricardo – Pipeup",
      "senderNameHint": "Only changes the display name. The actual email is the one configured in the system.",
      "deliveryLimitsTitle": "Default sending limit",
      "deliveryLimitsLoading": "Loading sending limits...",
      "deliveryLimitsError": "Could not load sending limits.",
      "deliveryLimitsEmpty": "Sending limits not configured. The system will use default values.",
      "deliveryLimitsMaxPerCampaign": "Max per campaign",
      "deliveryLimitsRateSummary": "{{perMinute}}/min • {{perHour}}/hour • {{perDay}}/day",
      "deliveryLimitsNoRestriction": "Sending hours: no restriction",
      "deliveryLimitsAllowedHours": "Allowed hours",
      "deliveryLimitsFooter": "Sends automatically respect these limits and may be queued.",
      "deliverabilityTips": "Deliverability tips",
      "tip1": "Use clear, natural subjects",
      "tip2": "Avoid too much CAPS or emojis",
      "tip3": "Don't use words like \"FREE!!!\" or \"URGENT\"",
      "segmentSelect": "Segment",
      "selectPlaceholder": "Select...",
      "segmentPreview": "Preview",
      "segmentOptionContacts": "{{count}} contacts",
      "segmentCount": "{{count}} contacts",
      "segmentPreviewHint": "Contacts that match the segment rules.",
      "segmentPreviewAuto": "Updated automatically",
      "segmentEmpty": "No contacts match this segment.",
      "preview": "Preview",
      "selectTemplate": "Select template",
      "createNewTemplate": "Create new template",
      "reviewSummary": "Campaign summary",
      "reviewName": "Name",
      "reviewSubject": "Subject",
      "reviewSegment": "Segment",
      "reviewEstimatedCount": "Estimated count",
      "reviewTemplate": "Template",
      "bestPractices": "Deliverability best practices",
      "bp1": "Avoid sending to contacts without consent",
      "bp2": "Use up-to-date segments",
      "bp3": "Don't send too many emails in a row",
      "sendNow": "Send now",
      "scheduleSend": "Schedule send",
      "scheduleAt": "Date and time",
      "copySuffix": "copy",
      "continue": "Continue",
      "sendCampaign": "Send campaign",
      "back": "Back",
      "wizardStepBasic": "Basic",
      "wizardStepSegment": "Segment",
      "wizardStepTemplate": "Template",
      "wizardStepSend": "Send",
      "wizardBasicData": "Basic data",
      "wizardChannel": "Channel",
      "wizardChannelEmailMvp": "Email (MVP)",
      "wizardReplyTo": "Reply-To",
      "wizardSelectSegment": "Select the segment",
      "wizardRecipientsCount": "{{count}} recipients",
      "wizardSelectTemplate": "Select the template",
      "wizardSendTitle": "Send",
      "wizardSchedule": "Schedule",
      "wizardUnsubscribedHint": "Unsubscribed contacts will be ignored automatically.",
      "wizardNext": "Next",
      "wizardCreateAnd": "Create and",
      "wizardStart": "start",
      "wizardScheduleVerb": "schedule",
      "errorFillNameAndSubject": "Fill in the name and subject.",
      "errorSelectSegment": "Select a segment.",
      "errorSelectTemplate": "Select a template.",
      "errorFillRequiredFields": "Fill in all required fields.",
      "errorCreatedWithoutId": "Campaign created but no ID was returned. Try opening the campaign and starting it manually.",
      "successCreated": "Campaign created.",
      "successCreatedAndStarted": "Campaign created and sending started.",
      "errorCreatedButStartFailed": "Campaign created, but sending failed to start. Try starting it from the campaign page.",
      "successCreatedAndScheduled": "Campaign created and scheduled.",
      "errorCreateCampaign": "Error creating campaign.",
      "successArchived": "Campaign archived.",
      "errorArchive": "Error archiving campaign.",
      "detailStartedAt": "Started on",
      "detailPause": "Pause",
      "detailResume": "Resume",
      "cancelCampaign": "Cancel campaign",
      "detailProgressOf": "of",
      "detailEmailsSent": "emails sent",
      "detailTotalRecipients": "Total recipients",
      "detailOpens": "Opens",
      "detailClicks": "Clicks",
      "detailUnsubscribed": "Unsubscribed",
      "detailSent": "Sent",
      "detailFailed": "Failed",
      "detailSkipped": "Skipped",
      "detailDetails": "Campaign details",
      "detailSegment": "Segment",
      "detailTemplate": "Template",
      "detailSchedule": "Schedule",
      "detailStartDate": "Start date",
      "detailPreview": "Email preview",
      "detailShowPreview": "Show preview",
      "detailHidePreview": "Hide preview",
      "detailActivity": "Activity",
      "detailNoEvents": "No events yet.",
      "detailNoTemplateContent": "No template content.",
      "detailEventSent": "Email sent",
      "detailEventFailed": "Send failed",
      "detailEventSkipped": "Skipped",
      "detailCompletedTitle": "Campaign completed",
      "detailCompletedSummary": "Final summary",
      "detailViewReport": "View report",
      "detailDuplicateCampaign": "Duplicate campaign",
      "detailPaused": "Campaign paused.",
      "detailPauseError": "Error pausing campaign.",
      "detailResumed": "Campaign resumed.",
      "detailResumeError": "Error resuming campaign.",
      "detailCancelled": "Campaign cancelled.",
      "detailCancelError": "Error cancelling campaign."
    }
  },
  "customFields": {
    "title": "Custom Fields",
    "subtitle": "Configure additional fields for deals, companies, people and products.",
    "registerField": "Register Field",
    "searchPlaceholder": "Search fields...",
    "allEntities": "All Entities",
    "search": "Search",
    "loading": "Loading custom fields...",
    "emptyTitle": "No custom fields found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first custom field",
    "tableField": "Field",
    "tableEntity": "Entity",
    "tableDataType": "Data Type",
    "tableOptions": "Options",
    "tableRequired": "Required",
    "tableFilterable": "Filterable",
    "tableActions": "Actions",
    "editField": "Edit field",
    "deleteField": "Delete field",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} fields",
    "deleteModal": {
      "title": "Delete Custom Field",
      "message": "Are you sure you want to delete the field",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "drawer": {
      "subtitle": "Configure the custom field",
      "nameLabel": "Field Name",
      "namePlaceholder": "E.g. Priority",
      "uniqueKey": "Unique Key",
      "keyPlaceholder": "E.g. priority",
      "keyHintEdit": "The key cannot be changed after creation.",
      "keyHintNew": "Use only lowercase letters, numbers and underscore. Auto-generated from the name.",
      "entityType": "Entity Type",
      "entityPlaceholder": "Select the entity type",
      "entityHintEdit": "Entity type cannot be changed after creation.",
      "scopeLabel": "Field Scope",
      "globalFieldPipelines": "Global field (appears in all pipelines)",
      "selectPipelinesHint": "Select the pipelines where this field should appear:",
      "loadingPipelines": "Loading pipelines...",
      "noPipelines": "No pipelines available.",
      "globalFieldProducts": "Global field (appears in all products)",
      "selectProductsHint": "Select the products where this field should appear:",
      "loadingProducts": "Loading products...",
      "noProducts": "No products available.",
      "dataType": "Data Type",
      "selectDataType": "Select a data type",
      "dataTypeHintEdit": "Data type cannot be changed after creation.",
      "options": "Options",
      "optionsHint": "Add the options available for selection.",
      "optionPlaceholder": "Option name",
      "removeOption": "Remove option",
      "color": "Color",
      "addOption": "Add Option",
      "decimalPlaces": "Decimal Places",
      "decimalPlaceholder": "0 to 6 (leave empty for default)",
      "decimalHint": "Number of decimal places (0 to 6). Leave empty to use type default.",
      "required": "Required field",
      "filterable": "Allow filtering by this field",
      "cancel": "Cancel",
      "saveChanges": "Save Changes",
      "createField": "Create Field",
      "saving": "Saving..."
    },
    "entities": {
      "Deal": "Deal",
      "Organization": "Organization",
      "Person": "Person",
      "Product": "Product"
    },
    "dataTypes": {
      "Text": "Text",
      "ShortText": "Short Text",
      "LongText": "Long Text",
      "Number": "Number",
      "Integer": "Integer",
      "Decimal": "Decimal",
      "Currency": "Currency",
      "Date": "Date",
      "DateTime": "Date & Time",
      "Boolean": "Yes/No",
      "SingleSelect": "Dropdown",
      "MultiSelect": "Multi Select",
      "Tags": "Tags",
      "File": "File",
      "Url": "URL",
      "Phone": "Phone",
      "Email": "Email"
    }
  },
  "brands": {
    "title": "Brands",
    "subtitle": "Manage brands to organize your communication channels",
    "newBrand": "New brand",
    "edit": "Edit",
    "active": "Active",
    "inactive": "Inactive",
    "channelCount": "{{count}} channel connected",
    "channelsCount": "{{count}} channels connected",
    "empty": "No brands registered. Click new brand to create one.",
    "modalNew": {
      "title": "Create brand",
      "subtitle": "Define the name and logo used for support.",
      "name": "Name",
      "namePlaceholder": "E.g. Pipeup – Sales",
      "nameHelper": "This name is shown to the team in the inbox.",
      "logo": "Logo",
      "logoLabel": "Logo",
      "logoUploadEmpty": "PNG/JPG up to 2MB",
      "sendImage": "Upload image",
      "dropHere": "Drop here to upload",
      "logoUrlOptional": "Logo URL (optional)",
      "logoPlaceholder": "https://.../logo.png",
      "logoRecommended": "Recommended 512×512 (PNG with transparent background).",
      "logoUrlHint": "Paste your logo URL or select an image",
      "select": "Select",
      "changeLogo": "Change",
      "removeLogo": "Remove",
      "active": "Brand active",
      "activeDescription": "Available for use in the inbox.",
      "cancel": "Cancel",
      "create": "Create brand",
      "footerHint": "Tip: you can change this later."
    },
    "modalEdit": {
      "title": "Edit brand",
      "name": "Name",
      "namePlaceholder": "E.g. Premmio",
      "logo": "Logo (optional)",
      "logoLabel": "Logo",
      "logoPlaceholder": "https://example.com/logo.jpg",
      "logoUrlHint": "Paste your logo URL or select an image",
      "select": "Select",
      "changeLogo": "Change",
      "removeLogo": "Remove logo",
      "active": "Brand active",
      "deactivate": "Deactivate brand",
      "cancel": "Cancel",
      "save": "Save",
      "confirmDeactivate": "Are you sure you want to deactivate the brand {{name}}? It will no longer appear in the channel selector.",
      "no": "No",
      "yesDeactivate": "Yes, deactivate"
    }
  },
  "products": {
    "title": "Products",
    "subtitle": "Manage your company's products and services",
    "newProduct": "New Product",
    "searchPlaceholder": "Search products...",
    "allCategories": "All categories",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "search": "Search",
    "loading": "Loading products...",
    "loadError": "Error loading products",
    "retry": "Try Again",
    "emptyTitle": "No products found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first product",
    "tableProduct": "Product",
    "tableCategory": "Category",
    "tablePrice": "Price",
    "tableCode": "Code",
    "tableActive": "Active",
    "tableActions": "Actions",
    "editProduct": "Edit product",
    "deleteProduct": "Delete product",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} products",
    "deleteModal": {
      "title": "Delete Product",
      "message": "Are you sure you want to delete the product",
      "warning": "Deletion is permanent. The product will no longer appear in new proposals.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "drawer": {
      "titleNew": "New Product",
      "titleEdit": "Edit Product",
      "nameLabel": "Product Name",
      "namePlaceholder": "E.g. IT Consulting",
      "codeLabel": "Code",
      "codePlaceholder": "E.g. CTI-001",
      "codeHint": "Must be unique within the company",
      "description": "Description",
      "descriptionPlaceholder": "Product description",
      "unitPrice": "Unit Price",
      "billingCycle": "Billing Cycle",
      "priceRules": "Price rules (optional)",
      "enforcePriceRange": "Apply price range",
      "enforcePriceRangeHint": "Defines limits for discount and overprice on this product.",
      "maxDiscount": "Max discount (%)",
      "maxDiscountHint": "Allows selling up to X% below base price.",
      "maxOverprice": "Max overprice (%)",
      "maxOverpriceHint": "Allows selling up to X% above base price.",
      "requireReasonOutOfRange": "Require reason when out of range",
      "category": "Category",
      "categoryPlaceholder": "Select a category",
      "unit": "Unit",
      "unitPlaceholder": "Select a unit",
      "unitWarning": "Suggestion: for recurring billing, use unit 'month' or 'year'.",
      "active": "Active?",
      "cancel": "Cancel",
      "saveChanges": "Save Changes",
      "saveProduct": "Save Product",
      "saving": "Saving..."
    },
    "details": {
      "mainInfo": "Main Information",
      "name": "Name",
      "category": "Category",
      "price": "Price",
      "code": "Code",
      "unit": "Unit",
      "billingCycle": "Billing Cycle",
      "active": "Active",
      "yes": "Yes",
      "no": "No",
      "createdAt": "Created at",
      "updatedAt": "Updated at",
      "description": "Description",
      "notes": "Notes",
      "activate": "Activate",
      "edit": "Edit",
      "delete": "Delete"
    },
    "billingCycles": { "Monthly": "Monthly", "Yearly": "Yearly", "OneTime": "One-time" },
    "categories": { "Service": "Service", "Software": "Software", "Training": "Training", "Setup": "Setup", "Consulting": "Consulting", "Other": "Other" },
    "units": { "Unit": "Unit", "Hour": "Hour", "Day": "Day", "Month": "Month", "Year": "Year", "Project": "Project" }
  },
  "proposalTemplates": {
    "title": "Proposal Templates",
    "subtitle": "Manage your company's proposal templates",
    "createTemplate": "Create Template",
    "searchPlaceholder": "Search templates...",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "search": "Search",
    "loading": "Loading templates...",
    "loadError": "Error loading templates",
    "retry": "Try Again",
    "emptyTitle": "No templates found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first template",
    "tableModel": "Template",
    "tableType": "Type",
    "tableActive": "Active",
    "tableActions": "Actions",
    "deactivateTemplate": "Deactivate template",
    "activateTemplate": "Activate template",
    "editTemplate": "Edit template",
    "previewTemplate": "Preview",
    "duplicateTemplate": "Duplicate template",
    "deleteTemplate": "Delete template",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} templates",
    "deleteModal": {
      "title": "Delete Template",
      "message": "Are you sure you want to delete the template",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "previewModal": {
      "title": "Template Preview",
      "selectDeal": "Select a deal for preview",
      "selectDealPlaceholder": "Select a deal",
      "generating": "Generating...",
      "generatePreview": "Generate Preview",
      "generatingPreview": "Generating preview...",
      "clickToGenerate": "Click \"Generate Preview\" to view the rendered template.",
      "selectDealToPreview": "Select a deal to view the preview.",
      "tokenInfo": "Token Information",
      "tokensUsed": "Tokens used:",
      "tokensUnresolved": "Unresolved tokens:",
      "close": "Close"
    },
    "drawer": {
      "titleNew": "New Proposal Template",
      "titleEdit": "Edit Template:",
      "basicInfo": "Basic Information",
      "modelName": "Template Name",
      "modelNamePlaceholder": "E.g. Commercial Template, Technical Proposal, etc.",
      "modelNameHint": "This name will appear in the select when creating a new proposal.",
      "typeNoneOptional": "None (optional)",
      "modelType": "Template Type",
      "modelTypeHint": "Select the template type (optional).",
      "active": "Active?",
      "documentStructure": "Document Structure",
      "header": "Header",
      "documentTitle": "Document title",
      "documentTitlePlaceholder": "E.g. Commercial Proposal",
      "subtitle": "Subtitle (optional)",
      "subtitlePlaceholder": "E.g. Custom proposal for your company",
      "body": "Body",
      "introduction": "Introduction",
      "introPlaceholder": "Introductory text for the proposal...",
      "htmlCodePlaceholder": "Paste your HTML code here...",
      "customSections": "Custom sections",
      "addSection": "Add Section",
      "sectionTitlePlaceholder": "Section title",
      "sectionContentPlaceholder": "Section content...",
      "footer": "Footer",
      "finalNotes": "Final notes",
      "finalNotesPlaceholder": "Final notes...",
      "terms": "Terms and Conditions",
      "termsPlaceholder": "Terms and conditions...",
      "textMode": "Text Mode",
      "htmlMode": "HTML Mode",
      "toggleHtmlModeTitle": "Toggle HTML mode",
      "variablesTitle": "Available Variables",
      "variablesHint": "(Click on a field and then on the variable)",
      "activeFieldNone": "No field selected. Click on a text field to activate.",
      "activeFieldLabel": "Active field:",
      "preview": "Preview",
      "cancel": "Cancel",
      "saveTemplate": "Save Template",
      "saving": "Saving..."
    },
    "types": { "Commercial": "Commercial", "Technical": "Technical", "Custom": "Custom" }
  },
  "reports": {
    "title": "Reports",
    "refresh": "Refresh",
    "export": "Export",
    "saveView": "Save View",
    "tabs": {
      "overview": "Overview",
      "pipelines": "Pipelines",
      "deals": "Deals",
      "proposals": "Proposals",
      "activities": "Activities",
      "forecast": "Forecast"
    },
    "filters": {
      "period": "Period",
      "dateFrom": "From",
      "dateTo": "To",
      "pipelines": "Pipelines",
      "owners": "Owners",
      "status": "Status",
      "placeholderPipelines": "Select pipelines",
      "placeholderOwners": "Select owners",
      "placeholderStatus": "Select status",
      "moreFilters": "More Filters",
      "clear": "Clear",
      "activeFilters": "Active filters:",
      "minValue": "Min value",
      "maxValue": "Max value",
      "onlyWithProposal": "Only with proposal",
      "onlyOverdue": "Overdue only",
      "periodToday": "Today",
      "periodLast7d": "Last 7 days",
      "periodLast30d": "Last 30 days",
      "periodThisMonth": "This month",
      "periodLast3m": "Last 3 months",
      "periodThisYear": "This year",
      "periodCustom": "Custom",
      "dealStatusOpen": "Open",
      "dealStatusWon": "Won",
      "dealStatusLost": "Lost",
      "pipelineId": "Pipeline {{id}}",
      "userId": "User {{id}}"
    },
    "overview": {
      "kpiDealsCreated": "Deals Created",
      "kpiValueOpen": "Open Value",
      "kpiDealsWon": "Deals Won",
      "kpiConversionRate": "Conversion Rate",
      "kpiProposalsAccepted": "Proposals Accepted",
      "chartFunnel": "Conversion Funnel",
      "chartTrend": "Wins Trend",
      "chartRanking": "Owner Ranking",
      "insightsTitle": "Insights"
    },
    "pipelinesTab": {
      "chartConversionByStage": "Conversion by Stage",
      "chartTimeInStage": "Time in Stage (days)",
      "chartValueByStage": "Value by Stage"
    },
    "dealsTab": {
      "chartCreatedVsWon": "Created vs Won",
      "chartWonByOwner": "Won by Owner",
      "chartWonByPipeline": "Won by Pipeline",
      "loading": "Loading deals...",
      "empty": "No deals found",
      "headerDeal": "Deal",
      "headerCompany": "Company",
      "headerValue": "Value",
      "headerStage": "Stage",
      "headerOwner": "Owner",
      "headerStatus": "Status",
      "headerCreatedAt": "Created at",
      "paginator": "Showing {first} to {last} of {totalRecords} deals",
      "statusOpen": "Open",
      "statusWon": "Won",
      "statusLost": "Lost"
    },
    "proposalsTab": {
      "kpiAcceptanceRate": "Acceptance Rate",
      "kpiTotalProposals": "Total Proposals",
      "kpiPending": "Pending Proposals",
      "chartAging": "Proposal Aging",
      "chartByStatus": "Proposals by Status",
      "loading": "Loading proposals...",
      "empty": "No proposals found",
      "headerNumber": "Number",
      "headerDeal": "Deal",
      "headerCompany": "Company",
      "headerValue": "Value",
      "headerStatus": "Status",
      "headerCreatedAt": "Created at",
      "headerExpiry": "Expiry",
      "paginator": "Showing {first} to {last} of {totalRecords} proposals",
      "noDate": "—"
    },
    "activitiesTab": {
      "kpiTotal": "Total Activities",
      "kpiCompleted": "Completed",
      "kpiOverdue": "Overdue",
      "chartCompletedByPeriod": "Completed by Period",
      "chartOverdueByOwner": "Overdue by Owner",
      "chartByType": "Activities by Type",
      "loading": "Loading activities...",
      "empty": "No activities found",
      "headerTitle": "Title",
      "headerType": "Type",
      "headerRelatedTo": "Related to",
      "headerOwner": "Owner",
      "headerDueDate": "Due date",
      "headerStatus": "Status",
      "headerCompletedAt": "Completed at",
      "paginator": "Showing {first} to {last} of {totalRecords} activities",
      "statusPending": "Pending",
      "statusCompleted": "Completed",
      "statusOverdue": "Overdue",
      "noDate": "—"
    },
    "forecastTab": {
      "chartProjection": "Projection",
      "chartByOwner": "Projection by Owner",
      "chartByPipeline": "Projection by Pipeline",
      "topOpportunities": "Top Opportunities",
      "loading": "Loading opportunities...",
      "empty": "No opportunities found",
      "headerDeal": "Deal",
      "headerValue": "Value",
      "headerProbability": "Probability",
      "headerExpectedValue": "Expected Value"
    },
    "toast": {
      "dataUpdated": "Data updated",
      "exportTablesOnly": "Export is only available for tables",
      "noDataForExport": "No data available for export",
      "noRowsForExport": "No data available for export",
      "csvExported": "CSV file exported successfully!",
      "exportError": "Error exporting CSV file",
      "viewSaved": "View saved successfully!"
    },
    "exportMenu": {
      "csvCurrentTable": "CSV (current table)"
    },
    "csvHeaders": {
      "deal": "Deal",
      "company": "Company",
      "value": "Value",
      "stage": "Stage",
      "owner": "Owner",
      "status": "Status",
      "createdAt": "Created at",
      "closedAt": "Closed at",
      "number": "Number",
      "expiry": "Expiry",
      "acceptedAt": "Accepted at",
      "title": "Title",
      "type": "Type",
      "relatedTo": "Related to",
      "dueDate": "Due date",
      "completedAt": "Completed at",
      "probability": "Probability"
    }
  },
  "contacts": {
    "title": "Contacts",
    "subtitle": "Manage your contacts (People)",
    "newContact": "New Contact",
    "searchPlaceholder": "Search contacts...",
    "allCompanies": "All companies",
    "search": "Search",
    "loading": "Loading contacts...",
    "emptyTitle": "No contacts found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first contact",
    "tableContact": "Contact",
    "tableCompany": "Company",
    "tablePhoneEmail": "Phone / Email",
    "tableSource": "Source",
    "tableOwner": "Owner",
    "tableCreatedAt": "Created at",
    "tableActions": "Actions",
    "edit": "Edit",
    "associateToCompanyDeal": "Associate to company / deal",
    "delete": "Delete",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} contacts",
    "deleteModal": {
      "title": "Delete Contact",
      "message": "Are you sure you want to delete the contact",
      "warning": "This action is permanent. The contact will no longer appear in the list.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "associateModal": {
      "title": "Associate Contact",
      "message": "Associate",
      "messageTo": "to:",
      "company": "Company",
      "selectCompany": "Select a company",
      "deal": "Deal",
      "selectDeal": "Select a deal",
      "cancel": "Cancel",
      "associate": "Associate",
      "associating": "Associating..."
    },
    "drawer": {
      "editContact": "Edit Contact",
      "newContact": "New Contact",
      "subtitle": "Configure contact details",
      "name": "Name",
      "contactName": "Contact Name",
      "contactNameHint": "Name of the person who represents the contact",
      "email": "Email",
      "emailOrPhoneOptional": "(optional, but Email or Phone required)",
      "phone": "Phone",
      "whatsappOptIn": "Allow contact via WhatsApp",
      "position": "Position",
      "positionPlaceholder": "E.g. Sales Manager",
      "status": "Status",
      "statusPlaceholder": "E.g. Active, Inactive, Under review",
      "source": "Source",
      "responsible": "Owner",
      "selectResponsible": "Select an owner",
      "company": "Company",
      "selectCompany": "Select a company",
      "description": "Description",
      "descriptionPlaceholder": "Notes about the contact",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create",
      "saving": "Saving...",
      "namePlaceholder": "E.g. João Pereira",
      "contactNamePlaceholder": "E.g. João",
      "emailPlaceholder": "example@email.com"
    },
    "errors": {
      "load": "Error loading contacts. Please try again.",
      "loadContact": "Error loading contact data.",
      "delete": "Error deleting contact. Please try again.",
      "update": "Error updating contact. Please try again.",
      "create": "Error creating contact. Please try again.",
      "associate": "Error associating contact. Please try again.",
      "associateNeedCompanyOrDeal": "You must provide at least a Company or a Deal to associate."
    },
    "toast": {
      "saved": "Contact created successfully!",
      "updated": "Contact updated successfully!",
      "deleted": "Contact deleted successfully!",
      "deletedWithName": "Contact \"{{name}}\" deleted successfully!",
      "associated": "Contact associated successfully!"
    },
    "validation": {
      "nameRequired": "Name is required.",
      "nameMax": "Name must be at most 200 characters.",
      "contactNameRequired": "Contact name is required.",
      "contactNameMax": "Contact name must be at most 200 characters.",
      "emailInvalid": "Email must be valid.",
      "emailOrPhoneRequired": "You must provide at least Email or Phone.",
      "phoneInvalid": "Invalid format. Use: +55 (11) 98765-4321",
      "phoneE164": "Phone must be in E.164 format (e.g. +5511987654321)."
    }
  },
  "companies": {
    "title": "Companies",
    "subtitle": "Manage your company base",
    "newCompany": "New Company",
    "searchPlaceholder": "Search companies…",
    "industry": "Industry",
    "owner": "Owner",
    "date": "Date",
    "dateToday": "Today",
    "date7days": "Last 7 days",
    "date30days": "Last 30 days",
    "dateCustom": "Custom",
    "dateTo": "to",
    "search": "Search",
    "loading": "Loading companies...",
    "empty": "No companies found.",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first company",
    "tableCompany": "Company",
    "tableCnpj": "KVK",
    "tablePrimaryContact": "Primary Contact",
    "tablePhoneEmail": "Phone / Email",
    "tableOwner": "Owner",
    "tableCreatedAt": "Created at",
    "tableActions": "Actions",
    "editCompany": "Edit company",
    "viewRelationships": "View relationships",
    "deleteCompany": "Delete company",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} companies",
    "deleteModal": {
      "title": "Delete Company",
      "message": "Are you sure you want to delete the company",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleting": "Deleting..."
    },
    "drawer": {
      "editCompany": "Edit Company",
      "newCompany": "New Company",
      "basicInfo": "Basic Information",
      "companyName": "Company Name",
      "companyNamePlaceholder": "E.g. TechPro Ltd",
      "tradeName": "Trade Name",
      "tradeNamePlaceholder": "E.g. TechPro",
      "cnpj": "KVK",
      "cnpjPlaceholder": "12345678",
      "industry": "Industry",
      "selectIndustry": "Select an industry",
      "size": "Size",
      "selectSize": "Select size",
      "sizeSmall": "Small",
      "sizeMedium": "Medium",
      "sizeLarge": "Large",
      "contact": "Contact",
      "contactName": "Contact Name",
      "contactNamePlaceholder": "E.g. João Silva",
      "email": "Email",
      "emailPlaceholder": "contact@company.com",
      "phone": "Phone (E.164)",
      "phoneFormat": "Format: +5511999999999",
      "whatsappOptIn": "Allow contact via WhatsApp",
      "website": "Website",
      "websitePlaceholder": "https://www.company.com",
      "address": "Address",
      "country": "Country",
      "countryPlaceholder": "Brazil",
      "state": "State",
      "statePlaceholder": "SP",
      "city": "City",
      "cityPlaceholder": "São Paulo",
      "addressLine1": "Address",
      "addressLine1Placeholder": "123 Example St",
      "complement": "Complement",
      "complementPlaceholder": "Room 45",
      "zipCode": "ZIP Code",
      "zipCodePlaceholder": "01234-567",
      "additionalInfo": "Additional Information",
      "status": "Status",
      "selectStatus": "Select status",
      "statusActive": "Active",
      "statusLead": "Lead",
      "statusInactive": "Inactive",
      "source": "Source",
      "selectSource": "Select source",
      "sourceWebForm": "Web Form",
      "sourceReferral": "Referral",
      "sourceColdCall": "Cold Call",
      "sourceEmail": "Email",
      "sourceEvent": "Event",
      "sourceOther": "Other",
      "description": "Description",
      "descriptionPlaceholder": "Description or notes about the company...",
      "responsible": "Owner",
      "selectResponsible": "Select an owner",
      "cancel": "Cancel",
      "saveCompany": "Save Company",
      "saving": "Saving...",
      "loadFallbackWarning": "Some data may be incomplete. Please check before saving."
    },
    "details": {
      "tabDetails": "Details",
      "tabContacts": "Contacts",
      "tabDeals": "Deals",
      "tabActivities": "Activities",
      "edit": "Edit",
      "cnpj": "KVK",
      "industry": "Industry",
      "responsible": "Owner",
      "contact": "Contact",
      "noContacts": "No contacts associated",
      "noDeals": "No deals associated",
      "probability": "Probability",
      "noActivities": "No activities recorded",
      "name": "Name",
      "position": "Position",
      "phone": "Phone",
      "email": "Email",
      "contacts": "Contacts"
    },
    "errors": {
      "load": "Error loading companies. Please try again.",
      "delete": "Error deleting company. Please try again.",
      "update": "Error updating company. Please try again.",
      "create": "Error creating company. Please try again."
    },
    "validation": {
      "nameRequired": "Company name is required.",
      "emailRequired": "Email is required.",
      "emailInvalid": "Invalid email.",
      "phoneRequired": "Phone is required.",
      "phoneE164": "Phone must be in E.164 format (e.g. +5511999999999)."
    },
    "toast": {
      "saved": "Company created successfully!",
      "updated": "Company updated successfully!",
      "deleted": "Company deleted successfully!",
      "deletedWithName": "Company \"{{name}}\" deleted successfully!"
    }
  },
  "preferences": {
    "pageTitle": "Company Settings",
    "pageSubtitle": "Customize identity, CRM preferences and integrations.",
    "readOnlyBadge": "Read only - Only administrators can make changes",
    "unsavedChangesBadge": "You have unsaved changes",
    "restoreDefaults": "Restore defaults",
    "saveChanges": "Save changes",
    "tabIdentity": "Main data",
    "tabPreferences": "Preferences",
    "tabSecurity": "Users & Security",
    "tabCommunication": "Communication",
    "tabIntegrations": "Integrations",
    "loadErrorTitle": "Could not load settings.",
    "loadErrorHint": "Please try again later.",
    "reload": "Reload",
    "identity": {
      "companyDataTitle": "Company data",
      "companyDataDesc": "Information used in proposals, communications and documents.",
      "tradeName": "Trade name",
      "legalName": "Legal name",
      "cnpj": "KVK",
      "phone": "Phone",
      "email": "Email",
      "emailFinancialHint": "Financial email for billing and invoices.",
      "timezone": "Timezone",
      "timezonePlaceholder": "Select a time zone",
      "timezoneHint": "IANA format (e.g. America/Sao_Paulo, America/New_York)",
      "optionalUsedInProposals": "Optional. Used in proposals and footers if provided.",
      "site": "Website",
      "logo": "Logo",
      "logoDesc": "Upload your brand for proposals and documents.",
      "logoLabel": "Logo",
      "changeLogo": "Change Logo",
      "select": "Select",
      "logoUrlHint": "Paste your logo URL or select an image",
      "removeLogo": "Remove logo",
      "logoPlaceholder": "https://example.com/logo.jpg",
      "addressTitle": "Address",
      "addressDesc": "Company location information.",
      "countryCode": "Country code",
      "state": "State",
      "city": "City",
      "zipCode": "ZIP code",
      "addressLine1": "Street",
      "addressNumber": "Number",
      "placeholders": {
        "tradeName": "e.g. Acme Corp",
        "legalName": "e.g. Acme Corp LLC",
        "cnpj": "12345678",
        "phone": "+55 11 98765-4321",
        "email": "contact@company.com",
        "city": "São Paulo",
        "zipCode": "01310-100",
        "addressLine1": "Street or Avenue",
        "addressNumber": "123",
        "countryCode": "BR",
        "state": "SP",
        "countryCodeHint": "ISO 3166-1 alpha-2 code (e.g. BR, US)",
        "stateHint": "State code (e.g. SP, RJ, MG)",
        "website": "https://..."
      }
    },
    "regional": {
      "title": "Regional",
      "desc": "Set language and date/currency formats.",
      "language": "Language",
      "currency": "Currency",
      "dateFormat": "Date format",
      "affectsLists": "Affects display in lists and reports.",
      "currencyBRL": "Real (BRL)",
      "currencyUSD": "US Dollar (USD)",
      "currencyEUR": "Euro (EUR)",
      "dateDDMM": "dd/MM/yyyy",
      "dateMMDD": "MM/dd/yyyy",
      "dateISO": "yyyy-MM-dd"
    },
    "notifications": {
      "title": "Notifications",
      "desc": "Sound when a new message arrives in Inbox (Instagram, WhatsApp, Webchat).",
      "soundNewMessage": "New message sound",
      "volume": "Volume"
    },
    "accentPreview": "Preview",
    "buttonsPreview": "Buttons",
    "appliedOnlyProposals": "Applied only in proposals and documents.",
    "numbering": {
      "title": "Numbering",
      "desc": "Standardize proposal identifiers.",
      "prefix": "Prefix",
      "preview": "Preview",
      "sequenceAuto": "Sequence is generated automatically."
    },
    "automation": {
      "title": "Light automation",
      "desc": "Enable simple behaviors to standardize operations.",
      "countWeekends": "Count weekends in deadlines",
      "countWeekendsHint": "When off, deadlines ignore Saturday and Sunday."
    },
    "security": {
      "allowedDomainsTitle": "Allowed domains",
      "allowedDomainsDesc": "Restrict signup/login to specific domains.",
      "add": "Add",
      "domainHint": "Use only the domain. The system normalizes automatically (accepts @, http://, www., etc.). E.g. company.com, @company.com, https://www.company.com",
      "domainPlaceholder": "company.com",
      "policiesTitle": "Access policies",
      "policiesDesc": "Define simple rules for user control.",
      "requireCorporateDomain": "Require corporate domain",
      "requireCorporateDomainHint": "When enabled, only emails with domains from the list above can be registered.",
      "addOneDomainWarning": "Add at least 1 domain before enabling this option.",
      "manualApproval": "Manual approval of new users",
      "manualApprovalHint": "When enabled, new users stay pending until approval. Existing users are not affected."
    },
    "communication": {
      "deliverabilityTitle": "Deliverability",
      "deliverabilityDesc": "Rules to reduce spam risk.",
      "replyToDisclaimer": "If the user's Reply-To has a different domain than FromAddress, some providers may reduce delivery or mark as spam.",
      "replyToTitle": "Email replies (Reply-To)",
      "replyToDesc": "Configure where replies to sent emails will be directed.",
      "replyToUser": "Send replies directly to the salesperson",
      "replyToUserHint": "When enabled, the Reply-To field will be the responsible salesperson's email.",
      "howItWorks": "How it works",
      "howItWorksBody": "The From field remains the system's (e.g. noreply@pipeup.com.br). Only the Reply-To field changes to the responsible salesperson's email. When the recipient replies, the reply goes to the salesperson, not the system.",
      "deliverabilityWarningTitle": "Note: deliverability and tracking",
      "deliverabilityWarning1": "Replies will go directly to the salesperson's email (outside Pipeup).",
      "deliverabilityWarning2": "In some scenarios, there may be deliverability impact depending on the provider and recipient's DMARC policies.",
      "deliverabilityWarning3": "Recommended only for 1:1 communications (sales).",
      "emailSendingTitle": "Email sending",
      "emailSendingDesc": "Configure sender and sending provider.",
      "sendingMode": "Sending mode",
      "sendingModeDefault": "Pipeup default",
      "sendingModeSmtp": "Company SMTP",
      "smtpTitle": "Corporate SMTP",
      "smtpDesc": "Send emails using your domain (recommended for proposals).",
      "smtpHost": "SMTP Host",
      "smtpPort": "Port",
      "smtpPortSSL": "SSL",
      "smtpPortTLS": "TLS",
      "smtpPortDefault": "Default",
      "smtpUser": "User",
      "smtpPassword": "Password",
      "smtpPasswordHint": "Fill in only to change.",
      "smtpEncryption": "Encryption",
      "smtpPortHint": "Tip: 465 → SSL | 587 → TLS | 25 → No encryption",
      "smtpRecommended": "Recommended",
      "smtpPortWarning": "Port {{port}} usually uses {{encryption}}",
      "fromAddress": "From Address",
      "fromNameTemplate": "From Name Template",
      "fromNameTemplateHint": "Available tokens: user.name, company.name",
      "testSmtp": "Test SMTP",
      "whatsappLinkTitle": "WhatsApp (Link)",
      "whatsappLinkDesc": "Start WhatsApp conversations with pre-filled messages. Does not require API connection.",
      "enableWhatsApp": "Enable WhatsApp",
      "enableWhatsAppHint": "OFF → WhatsApp button does not appear in the system | ON → button appears in Person / Deal / Organization",
      "requireConsent": "Require contact consent",
      "requireConsentHint": "Only allow sending to contacts with active consent.",
      "templatesTitle": "WhatsApp templates",
      "templatesVariables": "Available variables: {{person.firstName}}, {{person.fullName}}, {{company.name}}, {{deal.title}}, {{deal.value}}, {{user.name}}",
      "templatesMax": "Maximum {{max}} templates ({{current}}/{{max}})",
      "templateNamePlaceholder": "Template name",
      "templateContentPlaceholder": "Message content...",
      "default": "Default",
      "addTemplate": "Add Template",
      "logActivity": "Log activity automatically",
      "logActivityHint": "Log an activity whenever WhatsApp is started."
    },
    "integrationsTab": {
      "webhooksTitle": "Webhooks",
      "webhooksDesc": "Receive Pipeup events in your systems.",
      "webhookUrl": "Webhook URL",
      "events": "Events",
      "active": "Active",
      "integrationsTitle": "Integrations",
      "integrationsDesc": "Connect tools used in your workflow.",
      "payin": "Payin",
      "currentPlan": "Current plan",
      "status": "Status",
      "googleCalendar": "Google Calendar",
      "googleCalendarDesc": "Sync events and activities",
      "nvoip": "Nvoip",
      "nvoipDesc": "WhatsApp Business API",
      "displayAfterConnection": "Will be displayed automatically after connection."
    },
    "testSmtpModal": {
      "title": "Test SMTP",
      "passwordWarning": "Important: Fill in the SMTP password in the form before testing. The password is not stored permanently in the browser for security.",
      "sendTestTo": "Send test to",
      "emailPlaceholder": "email@example.com",
      "sending": "Sending test email...",
      "sendTest": "Send test",
      "sendingBtn": "Sending..."
    },
    "identityPreviewModal": {
      "title": "Identity Preview",
      "subtitle": "Preview of how your identity will be applied in proposals and documents",
      "proposal": "Proposal",
      "validUntil": "Valid until",
      "client": "Client",
      "sampleCompany": "Sample Company Ltd.",
      "sampleCnpj": "KVK: 12345678",
      "sampleEmail": "contact@example.com",
      "itemsTitle": "Proposal Items",
      "item": "Item",
      "quantity": "Quantity",
      "unitValue": "Unit Value",
      "total": "Total",
      "sampleProductA": "Sample Product A",
      "sampleProductB": "Sample Product B",
      "acceptProposal": "Accept Proposal",
      "companyNameFallback": "Company Name"
    }
  },
  "roles": {
    "title": "Profiles",
    "subtitle": "Control user types and access permissions within the system.",
    "registerProfile": "Register Profile",
    "searchPlaceholder": "Search profiles...",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "search": "Search",
    "loading": "Loading profiles...",
    "emptyTitle": "No profiles found",
    "emptyWithFilters": "Try adjusting your search filters",
    "emptyNoFilters": "Start by creating your first profile",
    "tableName": "Name",
    "tableCategory": "Category",
    "tableDescription": "Description",
    "tableUsers": "Users",
    "tableStatus": "Status",
    "tableActions": "Actions",
    "categorySystem": "System",
    "categoryColaborador": "Collaborator",
    "userCountOne": "user",
    "userCountMany": "users",
    "zeroUsers": "0 users",
    "editProfile": "Edit profile",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} profiles",
    "drawer": {
      "titleNew": "Register Profile",
      "titleEdit": "Edit Profile",
      "titleEditName": "Edit Profile: {{name}}",
      "systemProfileHint": "System profile",
      "configurePermissionsHint": "Configure profile permissions",
      "profileName": "Profile Name",
      "namePlaceholder": "E.g. SDR, Closer, Support, CS",
      "description": "Description",
      "descriptionPlaceholder": "Brief explanation of this profile's role",
      "category": "Category",
      "permissions": "Permissions",
      "canViewTeamDeals": "Can view team deals",
      "canEditTeamDeals": "Can edit team deals",
      "canSendProposals": "Can send proposals",
      "canEditTeamProposals": "Can edit team proposals",
      "canViewFinancialData": "Can view financial data",
      "active": "Active",
      "usersLinkedInfo": "Linked users: This profile is used by {{count}} {{usersLabel}}.",
      "usersLinkedOne": "user",
      "usersLinkedMany": "users",
      "cancel": "Cancel",
      "register": "Register Profile",
      "saveProfile": "Save Profile",
      "saving": "Saving..."
    },
    "errors": {
      "load": "Error loading profiles. Please try again.",
      "companyRequired": "Could not identify company. Please log in again.",
      "process": "Error processing profile data. Please try again.",
      "update": "Error updating profile. Please try again.",
      "create": "Error creating profile. Please try again."
    },
    "toast": {
      "updated": "Profile \"{{name}}\" updated successfully!",
      "created": "Profile \"{{name}}\" created successfully!"
    },
    "validation": {
      "nameRequired": "Profile name is required."
    }
  },
  "users": {
    "title": "Users",
    "subtitle": "Manage users and access permissions for your company.",
    "newUser": "New User",
    "limitReached": "Limit reached ({{used}}/{{limit}}). Upgrade or add seats in Subscription.",
    "searchPlaceholder": "Search users...",
    "search": "Search",
    "loading": "Loading users...",
    "emptyTitle": "No users found",
    "emptyAdjustFilters": "Try adjusting your search filters",
    "emptyCreateFirst": "Start by creating your first user",
    "tableUser": "User",
    "tableEmail": "Email",
    "tableContact": "Contact",
    "tableProfile": "Profile",
    "tableStatus": "Status",
    "tableAccess": "Access",
    "tableActions": "Actions",
    "statusActive": "Active",
    "statusPending": "Pending",
    "statusInactive": "Inactive",
    "actionApprove": "Approve user",
    "actionEdit": "Edit user",
    "actionDelete": "Delete user",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} users",
    "deleteModal": {
      "title": "Delete User",
      "confirmMessage": "Are you sure you want to delete the user",
      "cannotUndo": "This action cannot be undone.",
      "cancel": "Cancel",
      "deleting": "Deleting...",
      "delete": "Delete"
    },
    "approveModal": {
      "title": "Approve User",
      "confirmMessage": "Are you sure you want to approve and activate the user",
      "afterApprove": "The user will be able to log in and access the system after approval.",
      "cancel": "Cancel",
      "approving": "Approving...",
      "approve": "Approve"
    },
    "limitModal": {
      "title": "User limit reached",
      "message": "Your company is using all available seats on the plan ({{used}}/{{limit}} seats).",
      "hint": "To add new users, upgrade your plan or add seats on the Subscription screen. There you can purchase extra seats and pay on the spot (PIX or card).",
      "close": "Close",
      "goToSubscription": "Go to Subscription"
    },
    "drawer": {
      "titleNew": "New User",
      "titleEdit": "Edit User",
      "subtitle": "Configure user data",
      "name": "Name",
      "email": "Email",
      "password": "Password",
      "phone": "Phone",
      "whatsapp": "WhatsApp",
      "type": "Type",
      "profile": "Profile",
      "timezone": "Time Zone",
      "namePlaceholder": "e.g. John Smith",
      "emailPlaceholder": "e.g. john@example.com",
      "phonePlaceholder": "(11) 91234-5678",
      "selectType": "Select user type",
      "typeAdministrator": "Administrator",
      "typeCollaborator": "Collaborator",
      "selectProfile": "Select a profile",
      "selectTimezone": "Select a time zone",
      "sameNumberWhatsApp": "Same number used for WhatsApp",
      "cancel": "Cancel",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "saveUser": "Save User",
      "allowedDomainsHint": "Allowed domains: {{domains}}",
      "validation": {
        "nameRequired": "Name is required.",
        "emailRequired": "Email is required.",
        "emailInvalid": "Invalid email.",
        "domainNotInList": "The domain \"{{domain}}\" is not in the allowed domains list.",
        "phoneRequired": "Phone is required.",
        "timezoneRequired": "Time zone is required.",
        "profileRequired": "Profile is required for collaborator."
      }
    },
    "errors": {
      "load": "Error loading users. Please try again.",
      "companyNotFound": "Could not identify company. Please log in again.",
      "loadUser": "Error loading user data. Please try again.",
      "delete": "Error deleting user. Please try again.",
      "approve": "Error approving user. Please try again.",
      "update": "Error updating user. Please try again.",
      "create": "Error creating user. Please try again.",
      "userIdNotFound": "User ID not found.",
      "domainNotAllowed": "The email domain is not in the company's allowed domains list."
    },
    "toast": {
      "deleted": "User \"{{name}}\" deleted successfully!",
      "updated": "User \"{{name}}\" updated successfully!",
      "created": "User \"{{name}}\" created successfully!",
      "approved": "User \"{{name}}\" approved and activated successfully!",
      "activated": "User \"{{name}}\" activated successfully!",
      "blocked": "User \"{{name}}\" blocked. System access has been disabled.",
      "pending": "User \"{{name}}\" will remain pending until approval."
    }
  },
  "integrations": {
    "googleCalendarDescription": "Connect your calendar to create and sync Pipeup meetings",
    "title": "Apps & Integrations",
    "subtitle": "Connect and manage integrations with your calendar, WhatsApp and other tools",
    "comingSoon": "Coming soon: new integrations",
    "searchPlaceholder": "Search integrations…",
    "filterAll": "All",
    "filterEnabled": "Enabled",
    "filterDisabled": "Disabled",
    "search": "Search",
    "tableIntegration": "Integration",
    "tableType": "Type",
    "tableProvider": "Provider",
    "tableStatus": "Status",
    "tableConnection": "Connection",
    "tableActions": "Actions",
    "disable": "Disable",
    "enable": "Enable",
    "configure": "Configure",
    "connect": "Connect",
    "emptyTitle": "No integrations found.",
    "emptyHint": "Try adjusting your search filters.",
    "paginatorReport": "Showing {first} to {last} of {totalRecords} integrations",
    "toggleModal": {
      "titleEnable": "Enable Integration",
      "titleDisable": "Disable Integration",
      "confirmEnable": "Are you sure you want to enable the integration <strong>{{name}}</strong>?",
      "confirmDisable": "Are you sure you want to disable the integration <strong>{{name}}</strong>?",
      "hintEnable": "When enabled, the integration will start working immediately.",
      "hintDisable": "When disabled, the integration will be paused and will not process events until re-enabled.",
      "cancel": "Cancel",
      "disabling": "Disabling...",
      "enabling": "Enabling...",
      "disableBtn": "Disable",
      "enableBtn": "Enable"
    },
    "oauthPopup": {
      "success": "Integration completed successfully.",
      "successHint": "You can close this window and return to the app.",
      "error": "Connection error.",
      "closeWindow": "Close this window"
    },
    "types": { "calendar": "Calendar", "webhook": "Automation" },
    "connection": {
      "none": "No configuration",
      "configured": "Configured",
      "oneConnection": "1 connection configured",
      "connectionsCount": "{{count}} connections configured",
      "errorTooltip": "Connection issue — reconnect"
    },
    "status": {
      "connected": "Connected",
      "disconnected": "Disconnected",
      "error": "Error",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "paused": "Paused",
      "notConfigured": "Not configured"
    },
    "lastCall": "Last call: {{date}}",
    "toast": {
      "googleConnected": "Google account connected successfully.",
      "googleUpdated": "Google Calendar updated successfully.",
      "integrationEnabled": "Integration \"{{name}}\" enabled successfully!",
      "integrationDisabled": "Integration \"{{name}}\" disabled successfully!",
      "connectError": "Connection error.",
      "sessionExpired": "Session expired. Please log in again."
    },
    "googleCalendar": {
      "title": "Google Calendar",
      "subtitle": "Connect a Google account to create and sync meetings",
      "loading": "Loading…",
      "statusSection": "Integration status",
      "integrationActive": "Integration active",
      "connectionSection": "Connection",
      "noAccount": "No account connected",
      "connectGoogle": "Connect Google account",
      "connectHint": "You will be able to choose which calendar will receive events.",
      "connectedAs": "Connected as:",
      "swapAccount": "Switch account",
      "disconnect": "Disconnect",
      "disconnecting": "Disconnecting…",
      "connectionError": "Connection issue: {{reason}}",
      "unknownError": "Unknown error",
      "reconnect": "Reconnect",
      "defaultCalendar": "Default calendar",
      "selectCalendar": "Select a calendar…",
      "primary": "Primary",
      "eventsHint": "Events created by Pipeup will be added here.",
      "behavior": "Behavior",
      "createOnSchedule": "Create events automatically when scheduling a meeting in Pipeup",
      "updateOnReschedule": "Update event when rescheduling in Pipeup",
      "cancelOnCancel": "Cancel event when cancelling in Pipeup",
      "close": "Close",
      "testConnection": "Test connection",
      "testing": "Testing…",
      "save": "Save",
      "saving": "Saving…",
      "selectCalendarRequired": "Select a calendar",
      "toast": {
        "sessionExpired": "Session expired. Close the modal and log in again if needed.",
        "loadError": "Error loading Google Calendar status.",
        "disconnected": "Account disconnected.",
        "disconnectError": "Error disconnecting.",
        "swapError": "Error switching account.",
        "connectionOk": "Connection OK.",
        "testError": "Error testing connection.",
        "connectUrlError": "Could not get connection link.",
        "saveCalendarError": "Error saving default calendar.",
        "saveError": "Error saving."
      }
    },
    "webhook": {
      "title": "Webhooks",
      "subtitle": "Receive external signups and create leads automatically in your pipelines.",
      "enableWebhooks": "Enable Webhooks",
      "back": "Back",
      "newWebhook": "New Webhook",
      "editWebhook": "Edit Webhook",
      "nameLabel": "Webhook name",
      "namePlaceholder": "E.g. Sales landing page",
      "pipeline": "Pipeline",
      "selectPipeline": "Select a pipeline",
      "initialStage": "Initial stage",
      "selectStage": "Select initial stage",
      "ownerOptional": "Owner (optional)",
      "noOwner": "No owner",
      "endpointActive": "Endpoint active",
      "cancel": "Cancel",
      "saveWebhook": "Save webhook",
      "save": "Save",
      "secretBannerTitle": "Secret generated for: {{name}}",
      "secretBannerHint": "Copy and store this Secret. For security, it will not be shown again.",
      "copy": "Copy",
      "dismissSecret": "Close",
      "yourWebhooks": "Your Webhooks",
      "createWebhook": "Create webhook",
      "emptyTitle": "No webhooks created",
      "emptyHint": "Create a webhook to integrate your site or system with Pipeup.",
      "tableName": "Name",
      "tableDestino": "Destination",
      "tableStatus": "Status",
      "tableLastCall": "Last call",
      "tableActions": "Actions",
      "statusActive": "Active",
      "statusPaused": "Paused",
      "copyUrl": "Copy URL",
      "edit": "Edit",
      "moreActions": "More actions",
      "regenerateSecret": "Regenerate secret",
      "deleteWebhook": "Delete webhook",
      "regenerateConfirmHint": "This will invalidate the current secret. You will need to update your integrator.",
      "regenerate": "Regenerate",
      "deleteModalTitle": "Delete webhook \"{{name}}\"?",
      "deleteModalHint": "This webhook will stop accepting requests immediately. This action cannot be undone.",
      "deleteConfirmLabel": "I understand this action is irreversible",
      "payloadExample": "Payload example (POST)",
      "payloadHint": "Pipeline and stage are set in the webhook configuration. The token must be sent in the X-Pipeup-Webhook-Token header.",
      "toast": {
        "webhooksEnabled": "Webhooks enabled.",
        "webhooksPaused": "Webhooks paused.",
        "toggleError": "Error changing status.",
        "created": "Webhook created successfully.",
        "updated": "Webhook updated.",
        "urlCopied": "URL copied.",
        "secretRegenerated": "Secret regenerated. Update your integrator.",
        "secretCopied": "Secret copied.",
        "exampleCopied": "Example copied.",
        "deleteSuccess": "Webhook deleted successfully.",
        "deleteError": "Error deleting webhook.",
        "regenerateError": "Error regenerating secret.",
        "saveError": "Error saving."
      },
      "validation": {
        "nameRequired": "Enter webhook name",
        "pipelineRequired": "Select a pipeline",
        "stageRequired": "Select initial stage"
      }
    },
    "catalog": {
      "title": "Add integration",
      "googleCalendarTitle": "Google Calendar",
      "googleCalendarDesc": "Connect your calendar to create and sync Pipeup meetings.",
      "add": "Add"
    },
    "drawer": {
      "title": "Integrations",
      "description": "Configure available integrations to connect Pipeup with other tools.",
      "emailTitle": "Email Integration",
      "emailDesc": "Connect your email account",
      "provider": "Provider",
      "whatsappTitle": "WhatsApp API (Nvoip)",
      "whatsappDesc": "Connect with Nvoip for messaging",
      "whatsappHint": "Configure Nvoip API credentials in advanced settings.",
      "googleCalendarTitle": "Google Calendar",
      "googleCalendarDesc": "Sync events and activities",
      "googleCalendarHint": "Sign in with your Google account to sync events.",
      "googleDriveTitle": "Google Drive",
      "googleDriveDesc": "Access and store files",
      "googleDriveHint": "Connect your Google Drive account to access files.",
      "webhooksTitle": "Basic Webhooks",
      "webhooksDesc": "Configure webhooks for custom integrations",
      "webhooksHint": "Configure webhook URLs in advanced settings.",
      "cancel": "Cancel",
      "save": "Save Integrations",
      "saving": "Saving..."
    }
  },
  "channels": {
    "title": "Channels",
    "subtitle": "Manage communication channels per brand",
    "brand": "Brand",
    "comingSoon": "Coming soon",
    "badgeComingSoon": "Coming soon",
    "recommended": "Recommended",
    "emptySelectBrand": "Select a brand to configure channels.",
    "ariaConnectInstagram": "Connect Instagram",
    "connect": "Connect",
    "configure": "Configure",
    "manage": "Manage",
    "statusConnected": "Connected",
    "statusNotConnected": "Not connected",
    "descriptions": {
      "whatsapp": "Official Meta channel via API",
      "instagram": "Direct messages in Inbox",
      "messenger": "Facebook Messenger conversations",
      "telegram": "Telegram bot integrated",
      "webchat": "Chat on your website"
    },
    "webchat": {
      "modalTitle": "Webchat",
      "modalSubtitle": "Brand: {{brand}}",
      "loading": "Loading settings...",
      "stepAppearance": "Appearance",
      "stepInstall": "Installation",
      "stepRouting": "Routing",
      "stepSecurity": "Security",
      "isEnabled": "Enable Webchat for this brand",
      "isEnabledHelper": "When enabled, the widget can be used on the site after installing the script.",
      "savedAsDraft": "Saved as draft",
      "sectionIdentity": "Identity",
      "sectionMessages": "Messages",
      "sectionTheme": "Theme",
      "displayName": "Display name",
      "displayNamePlaceholder": "Support {{brand}}",
      "displayNameHelper": "Shown at the top of the chat.",
      "displayNameWarning": "Required to activate",
      "welcomeMessage": "Welcome message",
      "welcomeMessageHelper": "Message sent automatically when the chat is opened.",
      "requireNameBeforeChat": "Ask for name before first message",
      "requireNameHelper": "Helps qualify leads but may reduce conversion.",
      "logoOptional": "Logo (optional)",
      "logoHintRecommended": "Recommended: PNG/SVG up to 1MB",
      "logoHintOptional": "Optional. If not set, we'll use initials.",
      "upload": "Upload",
      "useUrl": "Use URL",
      "changeLogo": "Change",
      "removeLogo": "Remove",
      "logoUploading": "Uploading…",
      "logoUrlLabel": "Paste URL",
      "logoUrlApply": "Apply",
      "logoUrlCancel": "Cancel",
      "logoUrlPlaceholder": "https://example.com/logo.png",
      "logoFileTypeError": "Invalid format. Use PNG/SVG.",
      "logoFileSizeError": "File must be at most 1MB.",
      "logoUrlInvalid": "URL must start with https://",
      "primaryColor": "Primary color",
      "primaryColorInvalid": "Invalid color",
      "theme": "Theme",
      "themeLight": "Light",
      "themeDark": "Dark",
      "themeAuto": "Auto",
      "position": "Widget position",
      "positionBottomRight": "Bottom right",
      "positionBottomLeft": "Bottom left",
      "preview": "Preview",
      "allowedOriginsWarning": "You will configure this in the Security step.",
      "publicKey": "Widget key (Public Key)",
      "publicKeyPlaceholder": "Generated when you save",
      "publicKeyEmptyHint": "Could not load the key. Reopen the modal.",
      "copy": "Copy",
      "copied": "Copied!",
      "copySnippet": "Copy snippet",
      "rotateKey": "Rotate key",
      "rotateKeySuccess": "New key generated. Update the snippet on your site.",
      "rotateKeyError": "Could not rotate key. Please try again.",
      "disableWebchat": "Disable Webchat",
      "enableWebchat": "Enable Webchat",
      "saved": "Settings saved",
      "installScript": "Installation script",
      "installHint": "Paste before </body>.",
      "allowedOriginsHint": "Works only on allowed domains (Security).",
      "installHowToTitle": "How to install on your site",
      "installStep1": "Copy the code above.",
      "installStep2": "Paste it before the </body> tag in your site's HTML.",
      "installStep3": "Publish the changes.",
      "installDomainsNote": "The widget will only work on the allowed domains configured in the Security step.",
      "installShowExample": "See example",
      "installExampleComment": "Your content",
      "createLeadAutomatically": "Create lead automatically",
      "defaultTeam": "Default team/queue",
      "noTeam": "None",
      "noTeamsHint": "No teams registered. Create a team in settings.",
      "businessHoursEnabled": "Respect business hours",
      "businessHoursStart": "Start",
      "businessHoursEnd": "End",
      "offlineMessage": "Offline message",
      "allowedOrigins": "Allowed domains (Allowed Origins)",
      "originPlaceholder": "https://www.yourdomain.com",
      "originFormatHint": "Use scheme + host, no path (e.g. https://www.example.com).",
      "testDomain": "Test domain",
      "testDomainBtn": "Test",
      "testDomainOk": "OK — Domain allowed.",
      "testDomainBlocked": "Blocked — Add this domain to the list above and save.",
      "originMustBeHttps": "Domain must start with https://",
      "originInvalid": "Invalid domain URL.",
      "add": "Add",
      "securityNote": "The widget only works on allowed domains. If you add a wrong domain, Webchat will not appear.",
      "cancel": "Cancel",
      "back": "Back",
      "next": "Next",
      "save": "Save",
      "saveAndActivate": "Save and activate",
      "saveDraft": "Save draft",
      "saveAndPublish": "Save and publish",
      "toastConfigSaved": "Settings saved",
      "badgeNotConfigured": "Not configured",
      "badgeActive": "Active",
      "badgeDisabled": "Disabled",
      "badgeIncomplete": "Incomplete configuration",
      "errorAllowedOriginsRequired": "Add at least one allowed domain to enable Webchat.",
      "errorDisplayNameRequired": "Enter the display name.",
      "errorDefaultTeamRequired": "With \"Create lead automatically\" on and teams registered, select a default team/queue.",
      "errorInvalidColor": "Invalid primary color (use #RRGGBB).",
      "errorOfflineMessageRequired": "Enter the offline message.",
      "errorBusinessHours": "Start time must be before end time.",
      "errorSave": "Could not save settings. Please try again.",
      "errorLogoUpload": "Could not upload logo. Check format (PNG/SVG, max 1MB) or try again."
    },
    "statusLimited": "Limited",
    "statusConfigPending": "Configuration pending",
    "statusError": "Error",
    "statusAttention": "Attention",
    "retry": "Retry",
    "loading": "Loading...",
    "emptyCreateBrand": "Create your first brand to manage channels.",
    "createBrand": "Create brand",
    "instagram": {
      "subtitle": "Direct messages in Inbox",
      "attentionTooltip": "Reconnect to receive and send messages again",
      "brandInactive": "Brand inactive",
      "wizardTitle": "Connect Instagram",
      "wizardSubtitle": "Connect your professional Instagram account to receive messages directly in Pipeup Inbox.",
      "stepProgress": "Progress",
      "step1BeforeContinue": "Before you continue, make sure:",
      "step1Check1": "Your Instagram account is Professional (Business or Creator)",
      "step1Check2": "It is linked to a Facebook Page",
      "step1Check3": "You are an Administrator of the Page",
      "step1AfterConnect": "After connecting:",
      "step1After1": "Instagram Direct messages will appear in your Inbox",
      "step1After2": "You can reply from Pipeup",
      "step1After3": "The conversation will be linked to your company",
      "step1CommonIssues": "If something doesn't work",
      "step1CommonIssuesDetail": "It's usually related to Page permissions or Instagram account type.",
      "step1CommonIssue1": "Personal Instagram doesn't work",
      "step1CommonIssue2": "Page without administrator permission",
      "step1CommonIssue3": "Account not properly linked to the Page",
      "step1HowToVerify": "How do I check if my account is set up correctly?",
      "step1HowToVerifyDetail": "Instagram → Settings → Account → Account type. Facebook → Page settings → Page roles.",
      "step1Cta": "Connect Instagram",
      "step1Intro": "To connect Instagram to Pipeup:",
      "step1Requirement": "You need a professional account linked to a Facebook Page.",
      "step1WhatHappens": "Instagram Direct messages will appear in the Pipeup Inbox.",
      "step2Connecting": "Connecting account…",
      "settingsTitle": "Configure Instagram",
      "step2Intro": "Log in with Facebook to authorize access to your pages and Instagram accounts.",
      "step2Cta": "Click the button below to open Facebook login in a new window.",
      "step2LoginFacebook": "Log in with Facebook",
      "step2ContinueHint": "Complete the Facebook login above to continue.",
      "step2WaitingAuth": "Waiting for authentication…",
      "step2HelpPopup": "Complete login in the popup to continue.",
      "step2Success": "Successfully connected to Meta.",
      "step2ErrorPopupBlocked": "Please allow popups to continue.",
      "step2ErrorPopupClosed": "Login window was closed before completing.",
      "step2ErrorMetaConnect": "Failed to connect Meta.",
      "errorCode": "Error code",
      "step3Page": "Facebook Page",
      "step3SelectPage": "Select a page",
      "step3LoadingPages": "Loading pages…",
      "step3LoadingPagesAux": "Fetching pages linked to your account…",
      "step3NoPagesPlaceholder": "No pages found",
      "step3NoPagesEmpty": "We didn't find any pages with Instagram linked…",
      "step3NoPagesFound": "No Facebook Pages were found. Make sure you are an admin of the Page and try again.",
      "step3NoPagesHint": "You need to be an admin of a Facebook Page with a linked Instagram account.",
      "step3TryAgain": "Try again",
      "step3ViewRequirements": "View requirements",
      "step3DebugTitle": "Debug (support)",
      "step3DebugBrandFlow": "Brand for this flow",
      "step3DebugRequestId": "Request ID",
      "step3DebugReason": "Reason",
      "step3DebugScopesMissing": "scopes.missing",
      "step3DebugGraphCalls": "graph.calls",
      "step3PagesError": "Could not load Facebook pages.",
      "step3IgAccount": "Instagram account",
      "step3SelectIg": "Select account",
      "step3NoIgLinked": "How to connect Instagram to a Page.",
      "step4NoInbox": "No Inbox registered. Create an Inbox first.",
      "step4LoadingInboxes": "Loading inboxes…",
      "step4NoInboxTitle": "No Inbox found",
      "step4NoInboxHint": "No problem — when you finish, we'll create a Main Inbox automatically.",
      "step4ManageInboxes": "Manage inboxes",
      "step4InboxCreatedNow": "Main Inbox created automatically.",
      "step4InvalidInboxId": "The selected Inbox is not valid. Please select another.",
      "step4InstagramFound": "Instagram found and linked.",
      "step4LinkInstagramInstruction": "Link a professional Instagram account to this Page in Meta Business Suite.",
      "step4LinkInstagramFirst": "You need to link an Instagram account to the page to continue.",
      "step4Title": "Confirm connection",
      "step4PageSelected": "Selected Page",
      "step4IgLinked": "Instagram linked",
      "step4ActivateHint": "When you activate, your Instagram Direct messages will start appearing in Pipeup Inbox.",
      "step4CtaActivate": "Activate channel",
      "step4CtaBack": "Back",
      "step4Activating": "Activating…",
      "step4ToastSuccess": "Instagram connected successfully.",
      "step4ErrorToken": "We couldn't complete authentication. Please try again.",
      "step4ErrorPages": "We didn't find any accessible pages. Make sure you're an admin of the Page.",
      "step4ErrorIgLinked": "This Page doesn't have a professional Instagram linked. Link it in Meta Business Suite and try again.",
      "step4ErrorWebhook": "Channel connected, but message receiving is not active yet. Contact support.",
      "step4ErrorActivationCode": "Invalid or expired activation code. Reconnect with Instagram.",
      "step5Done": "Instagram connected and active.",
      "cancel": "Cancel",
      "continue": "Continue",
      "back": "Back",
      "activateChannel": "Activate channel",
      "goToInbox": "Go to Inbox",
      "close": "Close",
      "connectedAccount": "Connected account",
      "inboxBinding": "Inbox binding",
      "attentionBanner": "The connection needs to be revalidated.",
      "reconnect": "Reconnect",
      "disconnectConfirmTitle": "Disconnect Instagram?",
      "disconnectConfirmMessage": "When you disconnect, you will stop receiving and sending messages here."
    },
    "connectLinkedin": {
      "title": "Connect LinkedIn",
      "body": "Authorize Pipeup to access your LinkedIn messages.",
      "cancel": "Cancel",
      "connectWithLinkedin": "Connect with LinkedIn"
    },
    "manageLinkedin": {
      "backChannels": "Channels",
      "backToChannels": "Back to channels",
      "disconnect": "Disconnect",
      "tabGeneral": "General",
      "tabInbox": "Inbox",
      "tabTechnical": "Technical",
      "hybridAlert": "Hybrid mode: LinkedIn messages are not synced yet. This connection is used for routing and configuration.",
      "status": "Status",
      "mode": "Mode",
      "displayName": "Display name",
      "profileUrl": "Profile URL",
      "type": "Type",
      "lastSync": "Last sync",
      "notSyncedYet": "Not synced yet",
      "linkedInbox": "Linked inbox",
      "defaultResponsible": "Default responsible",
      "autoTags": "Auto tags",
      "saveChanges": "Save changes",
      "selectInbox": "Select inbox",
      "noInboxes": "No inboxes available. Create one in settings.",
      "newTag": "New tag",
      "addTag": "Add tag",
      "webhookUrl": "Webhook URL",
      "copy": "Copy",
      "copied": "Copied",
      "enabledEvents": "Enabled events",
      "recentLogs": "Recent logs",
      "noRecentLogs": "No recent logs",
      "dateTime": "Date / Time",
      "event": "Event",
      "technicalNotAvailable": "Technical data not available.",
      "none": "None",
      "brandFallback": "Brand",
      "connectedAccount": "Connected account",
      "disconnectConfirmTitle": "Disconnect LinkedIn?",
      "disconnectConfirmMessage": "This will disable the channel for this brand.",
      "disconnectConfirmCancel": "Cancel",
      "disconnectConfirmConfirm": "Disconnect",
      "finishConfigCallout": "Finish configuration to activate the channel.",
      "saveAndActivate": "Save and activate",
      "cancel": "Cancel",
      "configSaved": "Configuration saved",
      "inboxRequired": "Please select an inbox."
    },
    "config": {
      "channelSetup": "Channel setup",
      "reconnect": "Reconnect",
      "disconnect": "Disconnect",
      "deactivate": "Deactivate",
      "viewSnippet": "View snippet",
      "tabGeneral": "General",
      "tabAttendees": "Attendees",
      "tabReplies": "Auto replies",
      "tabInbox": "Inbox",
      "tabTemplates": "Templates",
      "tabTechnical": "Technical",
      "tabInstallation": "Installation",
      "tabAppearance": "Appearance",
      "connectedNumber": "Connected number",
      "numberMasked": "Number masked for security.",
      "connectionStatus": "Connection status",
      "lastSync": "Last sync",
      "inboxIntro": "All messages from this channel go to Inbox. Lead/Deal are created manually in the chat.",
      "linkedBox": "Linked inbox",
      "defaultResponsible": "Default responsible (optional)",
      "linkedBoxPlaceholder": "E.g. Main Inbox",
      "responsiblePlaceholder": "For assignment in Inbox",
      "autoTags": "Auto tags (optional)",
      "autoTagsInboxHint": "For organization and filtering in Inbox.",
      "messageTemplates": "Message templates",
      "syncTemplates": "Sync templates",
      "templateName": "Name",
      "templateStatus": "Status",
      "templateLanguage": "Language",
      "webhookUrl": "Webhook URL",
      "webhookReadOnly": "Read-only. Configure this URL in Meta for Developers.",
      "events": "Events",
      "recentLogs": "Recent logs",
      "logTime": "Time",
      "logEvent": "Event",
      "logDetail": "Detail",
      "linkedinAccount": "Connected account",
      "linkedinProfileName": "Profile name",
      "linkedinUrl": "URL",
      "linkedinType": "Type",
      "linkedinLastSync": "Last sync",
      "linkedinWebhook": "Webhook",
      "linkedinWebhookUrl": "Webhook URL",
      "linkedinEventsEnabled": "Enabled events",
      "linkedinLogs": "Recent logs",
      "logDateTime": "Date/Time",
      "logStatus": "Status",
      "channelStatus": "Channel status",
      "channelStatusActive": "Connected and active. Last sync: a few minutes ago.",
      "displayName": "Display name (optional)",
      "businessHours": "Business hours",
      "businessHoursPlaceholder": "In production, business hours and out-of-office message would be configured here.",
      "whoAttends": "Who handles this channel",
      "whoAttendsIntro": "Assign team members to receive conversations from {{channelName}}.",
      "allInboxUsers": "All users with Inbox access",
      "default": "Default",
      "attendeesPlaceholder": "In production: user list with toggle per person.",
      "welcomeMessage": "Welcome message",
      "welcomeMessageIntro": "Sent automatically when a new conversation is started.",
      "messagePlaceholder": "Type your message...",
      "quickReplies": "Quick replies",
      "quickRepliesPlaceholder": "In production: text shortcuts and predefined replies.",
      "identification": "Identification",
      "attendantDisplayName": "Attendant display name",
      "attendantPlaceholder": "E.g. Sales Team",
      "avatar": "Avatar",
      "avatarPlaceholder": "Image URL",
      "language": "Language",
      "allowedDomains": "Allowed domains",
      "addDomain": "add domain",
      "status": "Status",
      "webchatActive": "Webchat active",
      "webchatInactiveHint": "When inactive, the widget will not be displayed on configured sites.",
      "snippet": "Snippet",
      "copy": "Copy",
      "snippetHint": "Paste before </body> on pages where the webchat should appear.",
      "authorizedDomains": "Authorized domains",
      "test": "Test",
      "openTestPage": "Open test page",
      "testPageHint": "Send a message to see it in Inbox.",
      "button": "Button",
      "primaryColor": "Primary color",
      "position": "Position",
      "positionRight": "Right",
      "positionLeft": "Left",
      "buttonText": "Button text (optional)",
      "buttonTextPlaceholder": "E.g. Contact us",
      "initialMessage": "Initial message",
      "quickButtons": "Quick buttons (max. 4)",
      "quickButtonN": "Button {{n}}",
      "remove": "Remove",
      "label": "Label",
      "buttonLabelPlaceholder": "Button label",
      "appliedTag": "Applied tag",
      "tagPlaceholder": "Tag (for organization and filtering in Inbox)",
      "add": "add",
      "newTag": "New tag",
      "addTag": "Add",
      "profileTypeProfile": "Profile",
      "profileTypePage": "Page"
    },
    "conectarCanal": {
      "stepOf": "Step {{step}} of {{maxStep}}",
      "linkedinAuthorize": "Authorize Pipeup to access your LinkedIn messages.",
      "tokenPlaceholder": "Paste the token or configuration URL provided by {{channelName}}.",
      "tokenLabel": "Token or URL",
      "tokenInputPlaceholder": "Paste here...",
      "reviewPermissions": "Review permissions and click Connect to activate the channel.",
      "channelPermissions": "Channel: {{channelName}}. In production, requested permissions would appear here.",
      "channelConnected": "{{channelName}} connected",
      "channelReadyInbox": "The channel can now receive conversations in Inbox.",
      "cancel": "Cancel",
      "connectLinkedIn": "Connect with LinkedIn",
      "continue": "Continue",
      "connect": "Connect",
      "close": "Close",
      "connectTitle": "Connect {{channelName}}",
      "almostThere": "Almost there"
    },
    "conectarWhatsApp": {
      "wizardTitle": "Connect WhatsApp",
      "subtitle": "Connect your WhatsApp Cloud API number to receive and send messages in Inbox.",
      "title": "Number details",
      "credentials": "Access token",
      "confirm": "Confirmation",
      "concluded": "Concluded",
      "connected": "Connected",
      "stepOf": "Step {{step}} of {{maxStep}}",
      "stepProgress": "Step — {{step}}/{{maxStep}}",
      "wabaId": "WABA ID",
      "wabaIdPlaceholder": "WhatsApp Business Account ID",
      "phoneNumberId": "Phone Number ID",
      "phoneNumberIdPlaceholder": "E.g. 123456789012345",
      "displayPhone": "Display phone",
      "displayPhonePlaceholder": "Optional",
      "verifiedName": "Verified name",
      "verifiedNamePlaceholder": "Optional",
      "accessToken": "Access Token",
      "accessTokenPlaceholder": "System User token (Meta)",
      "tokenHelptext": "Client System User token with WhatsApp Cloud API permission. Used only to operate this number; stored securely.",
      "validateConnection": "Validate connection",
      "connectAndValidate": "Connect and Validate",
      "confirmWindowRule": "I understand that messages outside the 24h window require a Utility/Auth template.",
      "chooseMethod": "Choose how you want to connect WhatsApp.",
      "methodCloud": "WhatsApp Cloud API",
      "methodOther": "Other provider",
      "comingSoon": "(coming soon)",
      "enterCredentials": "Enter your app credentials in Meta for Developers.",
      "businessAccountId": "Business Account ID",
      "businessAccountIdPlaceholder": "E.g. 987654321098765",
      "webhookVerifyToken": "Webhook Verify Token",
      "webhookVerifyTokenPlaceholder": "Token for webhook verification",
      "summary": "Summary",
      "summaryMethod": "Method:",
      "summaryPhone": "Number:",
      "summaryBusiness": "Business Account ID:",
      "summaryToken": "Access Token:",
      "summaryWebhook": "Webhook Verify Token:",
      "validating": "Validating connection…",
      "whatsappConnected": "WhatsApp connected",
      "channelReadyInbox": "The channel can now receive conversations in Inbox.",
      "cancel": "Cancel",
      "finish": "Finish",
      "continue": "Continue",
      "close": "Close"
    },
    "whatsapp": {
      "connect": "Connect WhatsApp",
      "connectAria": "Connect WhatsApp",
      "howToGetPhoneNumberId": "How to get phone_number_id",
      "howToGetPhoneNumberIdIntro": "Pipeup acts as Tech Provider and needs your number's phone_number_id from Meta for Developers.",
      "howToStep1": "Go to Meta for Developers > your app > WhatsApp > API Setup.",
      "howToStep2": "Under Phone numbers, copy the ID of the number you want to connect.",
      "howToStep3": "Use the same token with whatsapp_business_messaging and whatsapp_business_management permissions.",
      "emptyState": "Pipeup acts as Tech Provider. Connect your number's phone_number_id to receive and send messages in Inbox.",
      "manageNumbers": "Manage numbers",
      "manage": "Manage",
      "resolve": "Resolve",
      "footerLine": "Connect your WhatsApp Cloud API number.",
      "tokenError": "Token authentication error.",
      "numbersConnected": "{{count}} number(s) connected",
      "manageTitle": "Manage WhatsApp numbers",
      "loadingAccounts": "Loading numbers…",
      "noNumbers": "No numbers connected.",
      "numberId": "Number",
      "test": "Test",
      "copyPhoneNumberId": "Copy Phone Number ID",
      "diagnostic": "Diagnostic",
      "loadingDiagnostic": "Loading…",
      "noDiagnostic": "No diagnostic data available.",
      "tokenInvalid": "Invalid token or no permission for this number.",
      "phoneNumberIdNotFound": "Phone Number ID not accessible with this token.",
      "validateError": "Error validating connection. Check the data and try again."
    },
    "close": "Close",
    "confirmDesconectar": {
      "title": "Disconnect {{channelName}}?",
      "description": "Existing conversations remain in Inbox. The channel will stop receiving new messages until reconnected.",
      "disableWebchatTitle": "Deactivate Webchat?",
      "disableWebchatDesc": "When deactivated, the widget will not appear on the site.",
      "disconnectLinkedInTitle": "Disconnect LinkedIn?",
      "disconnectLinkedInDesc": "When disconnected, you will no longer receive LinkedIn messages in Inbox.",
      "confirmLabel": "Confirm",
      "cancel": "Cancel",
      "disconnect": "Disconnect",
      "waiting": "Please wait…",
      "disconnecting": "Disconnecting…"
    },
    "verSnippet": {
      "title": "Webchat Snippet",
      "noSnippet": "(No snippet configured)",
      "copy": "Copy",
      "copied": "Copied!",
      "close": "Close"
    },
    "adicionarDominio": {
      "title": "Add domain",
      "domainLabel": "Domain",
      "domainPlaceholder": "e.g. yourdomain.com",
      "cancel": "Cancel",
      "save": "Save"
    }
  }
}
